// Master Policies Data for VSR Insurance Plus
// Verified insurer details for LIC of India & HDFC ERGO General Insurance (HEALTH ONLY)
// Managed by Senior Insurance Advisor V. S. Reddy (25+ Years Experience since 2000)

export const licPlans = [
  {
    "id": "lic-jeevan-utsav",
    "name": "LIC Jeevan Utsav (Plan 871)",
    "nameTe": "ఎల్‌ఐసి జీవన్ ఉత్సవ్ (ప్లాన్ 871)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 871 | UIN: 512N363V01",
    "category": "retirement_planning",
    "type": "lic",
    "tag": "10% Guaranteed Income For Life",
    "tagTe": "జీవితాంతం 10% హామీతో కూడిన వార్షిక ఆదాయం",
    "shortDesc": "Non-linked, non-participating, individual whole life savings plan offering guaranteed additions during premium term and 10% guaranteed income for life thereafter.",
    "shortDescTe": "ప్రీమియం చెల్లింపు కాలంలో హామీతో కూడిన అదనపు ప్రయోజనాలు మరియు జీవితాంతం 10% హామీతో కూడిన వార్షిక ఆదాయాన్ని అందించే సంపూర్ణ జీవిత బీమా పొదుపు పథకం.",
    "premium": "Starting @ ₹4,500/month",
    "premiumTe": "నెలకు ₹4,500 నుండి ప్రారంభం",
    "coverage": "₹5 Lakhs to No Upper Limit",
    "coverageTe": "₹5 లక్షల నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "10% of Basic Sum Assured paid annually for life after deferment",
      "Guaranteed Additions of ₹40 per thousand Sum Assured accrued each year during premium paying term",
      "Whole Life Risk Coverage up to age 100",
      "Limited Premium Payment Term: 5 to 16 years",
      "Flexi Income Option with 5.5% annual compound interest accumulation"
    ],
    "featuresTe": [
      "వాయిదా కాలం తర్వాత జీవితాంతం ప్రతి సంవత్సరం బేసిక్ సమ్ అష్యూర్డ్‌పై 10% హామీతో కూడిన ఆదాయం",
      "ప్రీమియం చెల్లింపు కాలంలో ప్రతి వేయి రూపాయల సమ్ అష్యూర్డ్‌పై సంవత్సరానికి ₹40 గ్యారెంటీడ్ అడిషన్స్",
      "100 సంవత్సరాల వయస్సు వరకు సంపూర్ణ జీవిత రిస్క్ కవరేజ్",
      "పరిమిత ప్రీమియం చెల్లింపు వ్యవధి: 5 నుండి 16 సంవత్సరాలు",
      "వార్షిక 5.5% చక్రవడ్డీతో కూడిన ఫ్లెక్సీ ఆదాయ ఎంపిక సదుపాయం"
    ],
    "eligibility": {
      "minAge": "90 days (completed)",
      "minAgeTe": "90 రోజులు (పూర్తయిన)",
      "maxAge": "65 years",
      "maxAgeTe": "65 సంవత్సరాలు",
      "minSumAssured": "₹5,00,000 (No upper limit)",
      "minSumAssuredTe": "₹5,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "100 minus age at entry",
      "policyTermTe": "100 మైనస్ చేరిన వయస్సు",
      "ppt": "5 to 16 years",
      "pptTe": "5 నుండి 16 సంవత్సరాలు"
    },
    "keyBenefits": [
      "Guaranteed Lifetime Income: 10% of Sum Assured credited annually to your bank account starting from deferment maturity.",
      "Flexi Income Accumulation: Defer receipt of the 10% payout and earn 5.5% compound interest, with 75% withdrawal flexibility at any time.",
      "Whole Life Security: Full life cover up to age 100 with sovereign guarantee under Section 37 of the LIC Act.",
      "Tax Exemptions: Eligible for deductions under Section 80C and payouts exempt under Section 10(10D) as per Indian tax laws."
    ],
    "keyBenefitsTe": [
      "జీవితాంతం గ్యారెంటీడ్ ఆదాయం: వాయిదా ముగిసిన తర్వాత ప్రతి సంవత్సరం 10% నగదు నేరుగా మీ బ్యాంక్ ఖాతాలో జమవుతుంది.",
      "ఫ్లెక్సీ ఆదాయ నిల్వ: 10% మొత్తాన్ని డ్రా చేయకుండా ఉంచితే LIC వార్షిక 5.5% చక్రవడ్డీతో పెంచుతుంది; ఎప్పుడైనా 75% వరకు విత్‌డ్రా చేసుకోవచ్చు.",
      "100 ఏళ్ల సంపూర్ణ రక్షణ: ఎల్‌ఐసి చట్టం సెక్షన్ 37 ప్రకారం కేంద్ర ప్రభుత్వ సార్వభౌమ హామీతో కూడిన జీవిత భద్రత.",
      "పన్ను మినహాయింపులు: ఆదాయపు పన్ను చట్టం సెక్షన్ 80C మరియు 10(10D) ప్రకారం వర్తించే పన్ను ప్రయోజనాలు."
    ],
    "limitations": [
      "Deferment period applies before income benefit begins (ranges from 1 to 5 years after PPT).",
      "Non-participating plan: No variable yearly bonus declarations beyond contractual terms.",
      "Standard 12-month suicide exclusion applies from policy commencement."
    ],
    "limitationsTe": [
      "ప్రీమియం చెల్లింపు కాలం తర్వాత ఎంచుకున్న వాయిదా సమయం (1 నుండి 5 సంవత్సరాలు) ముగిసిన తర్వాతే ఆదాయం ప్రారంభమవుతుంది.",
      "నాన్-పార్టిసిపేటింగ్ ప్లాన్: కాంట్రాక్టు నిబంధనలకు మించి అదనపు బోనస్‌లు ఉండవు.",
      "పాలసీ ప్రారంభమైన మొదటి 12 నెలల ఆత్మహత్య మినహాయింపు నిబంధన వర్తిస్తుంది."
    ],
    "payoutConditions": "Regular income commences after the deferment period and is paid annually until survival up to age 100. Upon death, Sum Assured on Death plus accrued Guaranteed Additions is paid to nominees.",
    "payoutConditionsTe": "వాయిదా కాలం తర్వాత ప్రతి సంవత్సరం 10% చొప్పున 100 ఏళ్ల వరకు చెల్లించబడుతుంది. ఒకవేళ పాలసీదారు మరణిస్తే సమ్ అష్యూర్డ్ ఆన్ డెత్ మరియు జమ అయిన గ్యారెంటీడ్ అడిషన్స్ నామినీకి అందజేయబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "LIC Jeevan Utsav is India’s premier sovereign-backed retirement and pension creation instrument. The 10% payout is contractually guaranteed for life and unaffected by market downturns.",
    "advisorNotesTe": "ఎల్‌ఐసి జీవన్ ఉత్సవ్ అనేది పదవీ విరమణ మరియు జీవితాంతం ఖచ్చితమైన ఆదాయం కోరుకునే వారికి భారతదేశంలోనే అత్యుత్తమమైన కేంద్ర ప్రభుత్వ హామీ గల ప్లాన్."
  },
  {
    "id": "lic-jeevan-shanti",
    "name": "LIC New Jeevan Shanti (Plan 858)",
    "nameTe": "ఎల్‌ఐసి న్యూ జీవన్ శాంతి (ప్లాన్ 858)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 858 | UIN: 512N338V04",
    "category": "retirement_planning",
    "type": "lic",
    "tag": "Guaranteed Single Premium Pension",
    "tagTe": "హామీతో కూడిన సింగిల్ ప్రీమియం పెన్షన్",
    "shortDesc": "Single premium deferred annuity plan providing guaranteed annuity rates from inception for individuals and joint lives.",
    "shortDescTe": "ఒకేసారి ప్రీమియం చెల్లించి జీవితాంతం హామీతో కూడిన స్థిరమైన పెన్షన్ పొందే సింగిల్ ప్రీమియం డిఫర్డ్ యాన్యుటీ ప్లాన్.",
    "premium": "Single Premium from ₹1,50,000",
    "premiumTe": "సింగిల్ ప్రీమియం ₹1,50,000 నుండి",
    "coverage": "Guaranteed Lifetime Annuity",
    "coverageTe": "జీవితాంతం హామీ గల పెన్షన్",
    "features": [
      "Guaranteed lifetime annuity rates locked at inception",
      "Deferred Annuity options for Single Life and Joint Life (spouse, child, parent)",
      "Death benefit during deferment period guarantees capital protection",
      "Single premium payment with flexible deferment from 1 to 12 years",
      "Surrender and loan facilities available after 3 months"
    ],
    "featuresTe": [
      "పాలసీ తీసుకున్న రోజే జీవితాంతం వచ్చే పెన్షన్ రేటు ఖరారు చేయబడుతుంది",
      "ఒక్కరి కోసం లేదా ఉమ్మడిగా (భార్యాభర్తలు) పెన్షన్ పొందే వెసులుబాటు",
      "వాయిదా కాలంలో పాలసీదారు మరణించినా పెట్టుబడికి పూర్తి రక్షణ మరియు అదనపు ప్రయోజనం",
      "1 నుండి 12 సంవత్సరాల వరకు అనుకూలమైన వాయిదా సమయం",
      "3 నెలల తర్వాత లోన్ మరియు సరెండర్ సదుపాయం"
    ],
    "eligibility": {
      "minAge": "30 years (last birthday)",
      "minAgeTe": "30 సంవత్సరాలు",
      "maxAge": "79 years (last birthday)",
      "maxAgeTe": "79 సంవత్సరాలు",
      "minSumAssured": "₹1,50,000 (Minimum Purchase Price)",
      "minSumAssuredTe": "₹1,50,000 (కనిష్ట కొనుగోలు ధర)",
      "policyTerm": "Lifetime",
      "policyTermTe": "జీవితాంతం",
      "ppt": "Single Premium (One Time)",
      "pptTe": "సింగిల్ ప్రీమియం (ఒకేసారి)"
    },
    "keyBenefits": [
      "Guaranteed Annuity for Life: Lifetime pension payments guaranteed irrespective of future interest rate declines.",
      "Joint Life Option: Pension continues to the surviving spouse with 100% purchase price returned to nominees.",
      "High Purchase Price Rebate: Attractive higher annuity incentives for investments above ₹5 Lakhs.",
      "Convenient Payout Modes: Choose monthly, quarterly, half-yearly, or annual pension credits."
    ],
    "keyBenefitsTe": [
      "జీవితాంతం స్థిరమైన పెన్షన్: భవిష్యత్తులో బ్యాంక్ వడ్డీ రేట్లు తగ్గినా మీ పెన్షన్ మారదు.",
      "జాయింట్ లైఫ్ ప్రయోజనం: జీవిత భాగస్వామి బతికి ఉన్నంత వరకు పెన్షన్ అందుతుంది, ఆ తర్వాత అసలు మొత్తం నామినీకి చేరుతుంది.",
      "పెద్ద మొత్తాలపై రాయితీ: ₹5 లక్షలకు పైగా పెట్టుబడులపై అదనపు పెన్షన్ రాయితీలు.",
      "అనుకూలమైన చెల్లింపులు: నెలకు, మూడు నెలలకు, ఆరు నెలలకు లేదా సంవత్సరానికి ఒకసారి పెన్షన్ తీసుకోవచ్చు."
    ],
    "limitations": [
      "Annuity payments are taxable as per applicable income tax slabs in the year of receipt.",
      "Cannot be surrendered within the first 3 months from inception.",
      "Deferment period cannot be changed once chosen."
    ],
    "limitationsTe": [
      "లభించే పెన్షన్ మొత్తంపై వర్తించే ఆదాయపు పన్ను నిబంధనల ప్రకారం పన్ను ఉంటుంది.",
      "మొదటి 3 నెలల్లో సరెండర్ చేయడం కుదరదు.",
      "ఒకసారి ఎంచుకున్న వాయిదా కాలాన్ని మార్చడం సాధ్యం కాదు."
    ],
    "payoutConditions": "Pension begins at the end of the deferment period and continues for life. Purchase price is returned to nominees upon death of the annuitant.",
    "payoutConditionsTe": "వాయిదా కాలం పూర్తయిన వెంటనే పెన్షన్ ప్రారంభమై జీవితాంతం అందుతుంది. ఆ తర్వాత అసలు మొత్తం నామినీకి అందుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "Ideal for individuals approaching retirement (age 45-60) who want to lock in high guaranteed interest rates now for their golden years.",
    "advisorNotesTe": "రిటైర్‌మెంట్ సమీపిస్తున్న వారికి స్థిరమైన, నమ్మకమైన నెలవారీ పెన్షన్ సమకూర్చడానికి ఇది అత్యుత్తమ పథకం."
  },
  {
    "id": "lic-saral-pension",
    "name": "LIC Saral Pension (Plan 862)",
    "nameTe": "ఎల్‌ఐసి సరళ్ పెన్షన్ (ప్లాన్ 862)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 862 | UIN: 512N342V03",
    "category": "retirement_planning",
    "type": "lic",
    "tag": "Immediate Lifetime Pension",
    "tagTe": "తక్షణ జీవితాంత పెన్షన్",
    "shortDesc": "Standard immediate annuity plan with 100% return of purchase price to nominee upon death of annuitant.",
    "shortDescTe": "ఒకేసారి పెట్టుబడి పెట్టి మరుసటి నెల నుండే జీవితాంతం తక్షణ పెన్షన్ మరియు 100% అసలు వాపసు పొందే ప్రామాణిక పథకం.",
    "premium": "Single Premium from ₹2,50,000",
    "premiumTe": "సింగిల్ ప్రీమియం ₹2,50,000 నుండి",
    "coverage": "Immediate Lifetime Pension",
    "coverageTe": "తక్షణ జీవితాంత పెన్షన్",
    "features": [
      "Immediate pension payout starting next month",
      "Option 1: Life Annuity with 100% Return of Purchase Price (ROP)",
      "Option 2: Joint Life Last Survivor Annuity with 100% ROP on death of last survivor",
      "Loan facility available after 6 months",
      "Simple, IRDAI standardized policy terms"
    ],
    "featuresTe": [
      "మరుసటి నెల నుండే తక్షణమే ప్రారంభమయ్యే నెలవారీ పెన్షన్",
      "ఆప్షన్ 1: జీవితాంతం పెన్షన్ మరియు మరణానంతరం 100% అసలు మొత్తం వాపసు",
      "ఆప్షన్ 2: దంపతులిద్దరికీ జీవితాంతం పెన్షన్ మరియు చివరగా నామినీకి 100% అసలు వాపసు",
      "6 నెలల తర్వాత లోన్ సదుపాయం",
      "ఐఆర్‌డిఎఐ ప్రమాణీకరించిన సులభతర నిబంధనలు"
    ],
    "eligibility": {
      "minAge": "40 years",
      "minAgeTe": "40 సంవత్సరాలు",
      "maxAge": "80 years",
      "maxAgeTe": "80 సంవత్సరాలు",
      "minSumAssured": "Minimum annuity of ₹1,000/month",
      "minSumAssuredTe": "కనిష్ట పెన్షన్ నెలకు ₹1,000",
      "policyTerm": "Lifetime",
      "policyTermTe": "జీవితాంతం",
      "ppt": "Single Premium",
      "pptTe": "సింగిల్ ప్రీమియం"
    },
    "keyBenefits": [
      "Immediate Income: Start receiving regular pension from month 1 without waiting years.",
      "Complete Capital Safety: 100% of purchase price refunded to family nominees upon demise.",
      "Lifelong Peace of Mind: Insulated from market volatility and bank interest cuts."
    ],
    "keyBenefitsTe": [
      "తక్షణ ఆదాయం: ఎలాంటి నిరీక్షణ లేకుండా మొదటి నెల నుండే క్రమం తప్పకుండా పెన్షన్.",
      "పెట్టుబడికి 100% భద్రత: పాలసీదారు మరణించిన తర్వాత పెట్టిన పూర్తి పెట్టుబడి నామినీకి చెల్లించబడుతుంది.",
      "మార్కెట్ నష్టాల భయం లేని శాశ్వత ఆర్థిక భరోసా."
    ],
    "limitations": [
      "Annuity received is subject to income tax.",
      "No deferment option (for deferred annuity choose New Jeevan Shanti)."
    ],
    "limitationsTe": [
      "వచ్చే పెన్షన్ ఆదాయంపై సాధారణ ఆదాయపు పన్ను వర్తిస్తుంది.",
      "వాయిదా వేసే అవకాశం లేదు (వాయిదా కోసం జీవన్ శాంతి ఎంచుకోవాలి)."
    ],
    "payoutConditions": "Pension starts immediately based on frequency chosen (monthly/quarterly/half-yearly/yearly). 100% purchase price paid back on death.",
    "payoutConditionsTe": "ఎంచుకున్న విధానం ప్రకారం వెంటనే పెన్షన్ ప్రారంభమవుతుంది. మరణానంతరం 100% అసలు వాపసు ఇవ్వబడుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "The most straightforward immediate pension plan for senior citizens and retirees with lump sum retirement funds from PF or Gratuity.",
    "advisorNotesTe": "పీఎఫ్ లేదా గ్రాట్యుటీ నుండి పెద్ద మొత్తం చేతికి వచ్చిన వారికి తక్షణ నెలవారీ పెన్షన్ కోసం అత్యంత అనువైన ప్లాన్."
  },
  {
    "id": "lic-amrit-baal",
    "name": "LIC Amritbaal (Plan 874)",
    "nameTe": "ఎల్‌ఐసి అమృతబాల్ (ప్లాన్ 874)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 874 | UIN: 512N365V01",
    "category": "children_future",
    "type": "lic",
    "tag": "Highest Guaranteed Return for Child",
    "tagTe": "పిల్లల కోసం అత్యధిక గ్యారెంటీడ్ రాబడి",
    "shortDesc": "Non-linked, non-participating child education plan offering an industry-record ₹80 per thousand Sum Assured guaranteed additions each year.",
    "shortDescTe": "పిల్లల ఉన్నత విద్య మరియు వివాహం కోసం ప్రతి వేయి రూపాయలకు సంవత్సరానికి ₹80 రికార్డు హామీతో కూడిన అదనపు ప్రయోజనాన్ని అందించే ప్రత్యేక పథకం.",
    "premium": "Starting @ ₹3,000/month",
    "premiumTe": "నెలకు ₹3,000 నుండి ప్రారంభం",
    "coverage": "₹2 Lakhs to No Limit",
    "coverageTe": "₹2 లక్షల నుండి పరిమితి లేదు",
    "features": [
      "Industry-record Guaranteed Additions of ₹80 per thousand Sum Assured accrued each policy year",
      "Entry age from 30 days to 13 years",
      "Maturity age from 18 to 25 years perfectly aligned with college and higher education milestones",
      "Flexible Premium Paying Term: Limited (5, 6, 7 years) or Single Premium",
      "Premium Waiver Benefit (PWB) Rider ensures child receives full benefits even if parent passes away"
    ],
    "featuresTe": [
      "పాలసీ కాలం మొత్తం ప్రతి వేయి రూపాయల సమ్ అష్యూర్డ్‌పై సంవత్సరానికి ₹80 రికార్డు గ్యారెంటీడ్ అడిషన్స్",
      "30 రోజుల పసిపిల్లల నుండి 13 ఏళ్ల లోపు పిల్లల వరకు చేరే అవకాశం",
      "కాలేజీ, ఉన్నత చదువుల ఖర్చులకు సరిగ్గా సరిపోయేలా 18 నుండి 25 ఏళ్ల వయస్సులో మెచ్యూరిటీ",
      "పరిమిత ప్రీమియం చెల్లింపు (5, 6, 7 సంవత్సరాలు) లేదా సింగిల్ ప్రీమియం వెసులుబాటు",
      "తల్లిదండ్రులకు ఏదైనా జరిగినా భవిష్యత్తు ప్రీమియంలు రద్దయ్యే ప్రీమియం వేవర్ బెనిఫిట్ (PWB) రైడర్"
    ],
    "eligibility": {
      "minAge": "30 days (completed)",
      "minAgeTe": "30 రోజులు (పూర్తయిన)",
      "maxAge": "13 years (last birthday)",
      "maxAgeTe": "13 సంవత్సరాలు",
      "minSumAssured": "₹2,00,000 (No upper limit)",
      "minSumAssuredTe": "₹2,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "10 to 25 years",
      "policyTermTe": "10 నుండి 25 సంవత్సరాలు",
      "ppt": "Limited: 5, 6, 7 years | Single: 1 year",
      "pptTe": "పరిమిత: 5, 6, 7 ఏళ్లు | సింగిల్: 1 సంవత్సరం"
    },
    "keyBenefits": [
      "Guaranteed Education Fund: Contractual ₹80/thousand GA guarantees an unassailable college corpus immune to stock market crashes.",
      "Flexible Maturity Age: Set payout date between age 18 and 25 to match undergraduate, postgraduate, or wedding expenses.",
      "Installment Settlement: Receive maturity payout in lump sum or spread across 5, 10, or 15 yearly installments.",
      "Comprehensive Life Protection: Sum Assured on Death plus accrued Guaranteed Additions paid upon unfortunate demise of child."
    ],
    "keyBenefitsTe": [
      "ఖచ్చితమైన విద్యా నిధి: ప్రతి ₹1000కి ₹80 గ్యారెంటీ వల్ల మార్కెట్ ఒడిదుడుకులతో సంబంధం లేకుండా పిల్లల భవిష్యత్తుకు పూర్తి భరోసా.",
      "అనుకూలమైన మెచ్యూరిటీ: 18 నుండి 25 ఏళ్ల వయస్సు మధ్య డిగ్రీ, పీజీ లేదా వివాహ సమయానికి నిధులు అందేలా రూపకల్పన.",
      "వాయిదాలలో తీసుకునే సౌలభ్యం: మెచ్యూరిటీ మొత్తాన్ని ఒకేసారి లేదా 5, 10, 15 సంవత్సరాల వాయిదాలలో తీసుకోవచ్చు.",
      "సంపూర్ణ కుటుంబ రక్షణ మరియు పన్ను మినహాయింపులు."
    ],
    "limitations": [
      "Non-participating plan: Bonus does not increase if LIC profits exceed estimates.",
      "Child must survive to maturity date for education payout unless death benefit is triggered."
    ],
    "limitationsTe": [
      "నాన్-పార్టిసిపేటింగ్ ప్లాన్: నిర్ణయించిన ₹80 కంటే అదనపు బోనస్ ఉండదు.",
      "పాలసీ నిబంధనల ప్రకారం క్లెయిమ్ మరియు మెచ్యూరిటీ నిబంధనలు వర్తిస్తాయి."
    ],
    "payoutConditions": "Basic Sum Assured + Accrued Guaranteed Additions (₹80/thousand per year) paid on maturity date or upon death during policy term.",
    "payoutConditionsTe": "మెచ్యూరిటీ సమయంలో బేసిక్ సమ్ అష్యూర్డ్ మరియు జమ అయిన గ్యారెంటీడ్ అడిషన్స్ (సంవత్సరానికి ₹80/వేయికి) చెల్లించబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "LIC Amritbaal is undeniably the most mathematically rewarding child plan launched by LIC in the last decade. Essential for every parent with a child under 13.",
    "advisorNotesTe": "గత దశాబ్ద కాలంలో పిల్లల కోసం ఎల్‌ఐసి ప్రవేశపెట్టిన పథకాలలో ఇది అత్యంత లాభదాయకమైనది మరియు సురక్షితమైనది."
  },
  {
    "id": "lic-jeevan-tarun",
    "name": "LIC Jeevan Tarun (Plan 934)",
    "nameTe": "ఎల్‌ఐసి జీవన్ తరుణ్ (ప్లాన్ 934)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 934 | UIN: 512N299V02",
    "category": "children_future",
    "type": "lic",
    "tag": "Flexible Child Money Back",
    "tagTe": "పిల్లల ఫ్లెక్సిబుల్ మనీ బ్యాక్",
    "shortDesc": "Participating child plan offering survival benefits from age 20 to 24 and maturity lump sum at age 25.",
    "shortDescTe": "పిల్లలకు 20 నుండి 24 ఏళ్ల వయస్సులో వార్షిక నిధులు మరియు 25వ ఏట భారీ మెచ్యూరిటీ మొత్తం అందించే లాభదాయక పథకం.",
    "premium": "Starting @ ₹2,500/month",
    "premiumTe": "నెలకు ₹2,500 నుండి ప్రారంభం",
    "coverage": "₹1 Lakh to No Upper Limit",
    "coverageTe": "₹1 లక్ష నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "4 flexible Survival Benefit payout options for child from age 20 to 24",
      "Maturity payout at age 25 with full vested bonuses and Final Additional Bonus",
      "Premium paying term: 20 minus entry age",
      "Premium Waiver Benefit (PWB) Rider available for parent",
      "Life cover increases automatically as child grows"
    ],
    "featuresTe": [
      "20 నుండి 24 ఏళ్ల వయస్సులో పిల్లల చదువుల కోసం 4 రకాల మనీ బ్యాక్ ఎంపికలు",
      "25వ ఏట బోనస్‌లు మరియు ఫైనల్ బోనస్‌తో కూడిన పూర్తి మెచ్యూరిటీ మొత్తం",
      "ప్రీమియం చెల్లింపు కాలం: 20 మైనస్ చేరిన వయస్సు",
      "తల్లిదండ్రులకు ప్రీమియం వేవర్ బెనిఫిట్ రైడర్ సదుపాయం",
      "వయస్సు పెరిగే కొద్దీ రిస్క్ కవరేజ్ భద్రత"
    ],
    "eligibility": {
      "minAge": "90 days (completed)",
      "minAgeTe": "90 రోజులు",
      "maxAge": "12 years (last birthday)",
      "maxAgeTe": "12 సంవత్సరాలు",
      "minSumAssured": "₹1,00,000 (No upper limit)",
      "minSumAssuredTe": "₹1,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "25 minus entry age",
      "policyTermTe": "25 మైనస్ చేరిన వయస్సు",
      "ppt": "20 minus entry age",
      "pptTe": "20 మైనస్ చేరిన వయస్సు"
    },
    "keyBenefits": [
      "Customized Money-Back: Choose Option 1 (No SB, 100% at maturity) to Option 4 (15% SA annually from age 20-24, 25% at maturity).",
      "Participating Bonuses: Earns Simple Reversionary Bonuses and Final Additional Bonus declared by LIC.",
      "Parental Peace of Mind: PWB rider ensures premiums are waived if proposer passes away."
    ],
    "keyBenefitsTe": [
      "అనుకూలమైన మనీ బ్యాక్: చదువుల అవసరాలను బట్టి 4 రకాల ఆప్షన్లలో ఒకదాన్ని ఎంచుకోవచ్చు.",
      "ఎల్‌ఐసి వార్షిక బోనస్‌లు మరియు మెచ్యూరిటీ అదనపు బోనస్ ప్రయోజనాలు.",
      "తల్లిదండ్రుల మరణానంతరం భవిష్యత్తు ప్రీమియంలు రద్దు చేయబడి పూర్తి ప్రయోజనాలు పిల్లలకే అందుతాయి."
    ],
    "limitations": [
      "Risk cover commences after 2 years from policy date or child attaining age 8, whichever is earlier.",
      "Loan is subject to minimum surrender value accumulation."
    ],
    "limitationsTe": [
      "రిస్క్ కవర్ 2 సంవత్సరాల తర్వాత లేదా పిల్లలకి 8 ఏళ్లు వచ్చిన తర్వాత ప్రారంభమవుతుంది.",
      "పాలసీ నిబంధనల ప్రకారం లోన్ సదుపాయం ఉంటుంది."
    ],
    "payoutConditions": "Survival benefits paid annually on completed age 20, 21, 22, 23, and 24. Remaining balance + bonuses paid at age 25.",
    "payoutConditionsTe": "20, 21, 22, 23, 24 ఏళ్ల వయస్సులో వార్షిక ప్రయోజనాలు, 25వ ఏట మిగిలిన మొత్తం మరియు బోనస్‌లు చెల్లించబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "A time-tested child plan specifically tailored for parents wanting annual cash flows during the critical college degree years (age 20-24).",
    "advisorNotesTe": "కాలేజీ చదువుల సమయంలో ఏటా ఖర్చుల కోసం క్రమం తప్పకుండా డబ్బులు కావాలనుకునే తల్లిదండ్రులకు ఇది సరైన ఎంపిక."
  },
  {
    "id": "lic-jeevan-anand",
    "name": "LIC New Jeevan Anand (Plan 915)",
    "nameTe": "ఎల్‌ఐసి న్యూ జీవన్ ఆనంద్ (ప్లాన్ 915)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 915 | UIN: 512N279V02",
    "category": "protect_family",
    "type": "lic",
    "tag": "Double Death Benefit + Whole Life",
    "tagTe": "డబుల్ డెత్ బెనిఫిట్ + జీవితాంత రక్షణ",
    "shortDesc": "Combination of financial protection against death throughout the lifetime of the insured with a lump sum maturity payment at the end of the selected policy term.",
    "shortDescTe": "పాలసీ కాలం ముగిసిన తర్వాత మెచ్యూరిటీ మొత్తం అందుకోవడంతో పాటు జీవితాంతం ఉచితంగా కొనసాగే రిస్క్ కవరేజ్ అందించే ప్రసిద్ధ ప్లాన్.",
    "premium": "Starting @ ₹2,200/month",
    "premiumTe": "నెలకు ₹2,200 నుండి ప్రారంభం",
    "coverage": "₹1 Lakh to No Limit",
    "coverageTe": "₹1 లక్ష నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "Lifetime whole life cover continues after maturity without any further premium payments",
      "Sum Assured on Death equals 125% of Basic Sum Assured or 7x annualized premium",
      "High bonus earning capacity with simple reversionary bonuses",
      "Accidental Death and Disability Benefit rider available",
      "Loan facility available after 2 full policy years"
    ],
    "featuresTe": [
      "మెచ్యూరిటీ తర్వాత కూడా ఎలాంటి ప్రీమియం చెల్లించనవసరం లేకుండా జీవితాంతం రిస్క్ కవరేజ్ కొనసాగుతుంది",
      "మరణించిన సందర్భంలో 125% సమ్ అష్యూర్డ్ లేదా 7 రెట్ల వార్షిక ప్రీమియం రక్షణ",
      "ఎల్‌ఐసి లాభాల ఆధారంగా అత్యధిక వార్షిక బోనస్ సంపాదన సామర్థ్యం",
      "ప్రమాదవశాత్తు మరణం మరియు అంగవైకల్యం రైడర్ రక్షణ",
      "2 సంవత్సరాల తర్వాత అత్యవసర లోన్ సదుపాయం"
    ],
    "eligibility": {
      "minAge": "18 years (completed)",
      "minAgeTe": "18 సంవత్సరాలు",
      "maxAge": "50 years (nearer birthday)",
      "maxAgeTe": "50 సంవత్సరాలు",
      "minSumAssured": "₹1,00,000 (No upper limit)",
      "minSumAssuredTe": "₹1,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "15 to 35 years",
      "policyTermTe": "15 నుండి 35 సంవత్సరాలు",
      "ppt": "Equal to policy term",
      "pptTe": "పాలసీ కాలానికి సమానం"
    },
    "keyBenefits": [
      "Double Protection: Receive maturity payout (Sum Assured + Bonuses) at term end, AND your nominee receives the Basic Sum Assured whenever you pass away in the future.",
      "Sovereign Security: Section 37 guarantee of LIC Act protects your principal and bonuses.",
      "Tax Relief: Premiums deductible under Section 80C, maturity and death benefits 100% tax-free under Section 10(10D)."
    ],
    "keyBenefitsTe": [
      "ద్వంద్వ ప్రయోజనం: టర్మ్ ముగిసినప్పుడు మీకు మెచ్యూరిటీ మరియు బోనస్ లభిస్తుంది, భవిష్యత్తులో మీరు ఎప్పుడు మరణించినా నామినీకి మళ్ళీ సమ్ అష్యూర్డ్ అందుతుంది.",
      "కేంద్ర ప్రభుత్వ సార్వభౌమ హామీతో కూడిన పూర్తి భద్రత.",
      "ఆదాయపు పన్ను చట్టం సెక్షన్ 80C మరియు 10(10D) ప్రకారం పూర్తి పన్ను మినహాయింపులు."
    ],
    "limitations": [
      "Premium paying term is equal to policy term (no limited pay option; for limited pay choose Jeevan Labh).",
      "Suicide exclusion within 12 months."
    ],
    "limitationsTe": [
      "పాలసీ కాలం మొత్తం ప్రీమియం చెల్లించాలి (పరిమిత చెల్లింపు కోసం జీవన్ లాభ్ ఎంచుకోవాలి).",
      "మొదటి 12 నెలల్లో ఆత్మహత్య మినహాయింపు నిబంధన ఉంటుంది."
    ],
    "payoutConditions": "Maturity: Basic Sum Assured + Vested Bonuses + FAB. Post-maturity death: Additional Basic Sum Assured to nominee.",
    "payoutConditionsTe": "మెచ్యూరిటీ సమయంలో సమ్ అష్యూర్డ్ + బోనస్‌లు. ఆ తర్వాత ఎప్పుడైనా మరణిస్తే నామినీకి అదనపు సమ్ అష్యూర్డ్ అందుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "LIC’s all-time flagship product (\"Zindagi ke Saath Bhi, Zindagi ke Baad Bhi\"). Unmatched for individuals wanting money in their hands plus legacy cover for their family.",
    "advisorNotesTe": "ఎల్‌ఐసి చరిత్రలోనే అత్యంత ప్రజాదరణ పొందిన ప్లాన్ (\"జిందగీ కే సాత్ భీ, జిందగీ కే బాద్ భీ\")."
  },
  {
    "id": "lic-jeevan-labh",
    "name": "LIC Jeevan Labh (Plan 936)",
    "nameTe": "ఎల్‌ఐసి జీవన్ లాభ్ (ప్లాన్ 936)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 936 | UIN: 512N304V02",
    "category": "wealth_creation",
    "type": "lic",
    "tag": "Highest Bonus Limited Pay Plan",
    "tagTe": "అత్యధిక బోనస్ పరిమిత చెల్లింపు ప్లాన్",
    "shortDesc": "Limited premium paying, non-linked, participating endowment plan offering exceptionally high bonus allocation and shorter payment terms.",
    "shortDescTe": "తక్కువ సంవత్సరాలు ప్రీమియం చెల్లించి ఎక్కువ సంవత్సరాలు రక్షణ మరియు అత్యధిక బోనస్ మెచ్యూరిటీ పొందే పొదుపు పథకం.",
    "premium": "Starting @ ₹2,800/month",
    "premiumTe": "నెలకు ₹2,800 నుండి ప్రారంభం",
    "coverage": "₹2 Lakhs to No Upper Limit",
    "coverageTe": "₹2 లక్షల నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "Pay for only 10, 15, or 16 years for policy terms of 16, 21, or 25 years",
      "Historically generates LIC’s highest annual bonus rates",
      "High Sum Assured rebate for investments above ₹5 Lakhs",
      "Comprehensive death benefit throughout policy term",
      "Loan facility available after 2 full premium years"
    ],
    "featuresTe": [
      "16, 21, లేదా 25 ఏళ్ల కాల వ్యవధికి కేవలం 10, 15, లేదా 16 సంవత్సరాలు మాత్రమే ప్రీమియం చెల్లింపు",
      "ఎల్‌ఐసి పథకాలన్నింటిలో అత్యధిక వార్షిక బోనస్ రేట్లు లభించే ప్లాన్",
      "₹5 లక్షలకు పైబడిన సమ్ అష్యూర్డ్‌పై ప్రత్యేక ప్రీమియం తగ్గింపు",
      "పాలసీ కాలం మొత్తం పూర్తి కుటుంబ రక్షణ",
      "2 సంవత్సరాల తర్వాత లోన్ తీసుకునే సదుపాయం"
    ],
    "eligibility": {
      "minAge": "8 years (completed)",
      "minAgeTe": "8 సంవత్సరాలు",
      "maxAge": "59 years (for 16-yr term)",
      "maxAgeTe": "59 సంవత్సరాలు",
      "minSumAssured": "₹2,00,000 (No upper limit)",
      "minSumAssuredTe": "₹2,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "16, 21, or 25 years",
      "policyTermTe": "16, 21, లేదా 25 సంవత్సరాలు",
      "ppt": "10, 15, or 16 years",
      "pptTe": "10, 15, లేదా 16 సంవత్సరాలు"
    },
    "keyBenefits": [
      "Shorter Commitments: Pay for only 16 years and enjoy guaranteed protection for 25 years with maximum bonus growth.",
      "Wealth Accumulation: High bonus allocation makes it the premier endowment choice for marriage and retirement lumpsums.",
      "Tax Efficiency: 100% tax exemption on maturity payouts under Section 10(10D)."
    ],
    "keyBenefitsTe": [
      "తక్కువ కాల పరిమితి: కేవలం 16 ఏళ్లు చెల్లించి 25 ఏళ్ల వరకు రక్షణ మరియు గరిష్ట మెచ్యూరిటీ ప్రయోజనం పొందవచ్చు.",
      "సంపద సృష్టి: పిల్లల పెళ్లిళ్లు, రిటైర్‌మెంట్ నిధి కోసం భారీ మొత్తం సమకూర్చే అద్భుత పథకం.",
      "సెక్షన్ 10(10D) ప్రకారం మెచ్యూరిటీపై పూర్తి పన్ను రహిత రాబడి."
    ],
    "limitations": [
      "Non-liquid during initial 2 years of inception.",
      "Maturity payout is in single lump sum (or installment settlement must be opted)."
    ],
    "limitationsTe": [
      "మొదటి 2 సంవత్సరాలలో పాలసీని సరెండర్ చేయడం నష్టదాయకం.",
      "మెచ్యూరిటీ మొత్తం సాధారణంగా ఒకేసారి చెల్లించబడుతుంది."
    ],
    "payoutConditions": "Basic Sum Assured + Vested Reversionary Bonuses + Final Additional Bonus paid at end of policy term.",
    "payoutConditionsTe": "పాలసీ కాలం ముగిసిన తర్వాత బేసిక్ సమ్ అష్యూర్డ్ + మొత్తం బోనస్‌లు + ఫైనల్ అడిషనల్ బోనస్ కలిపి చెల్లించబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "The number one wealth building plan in LIC’s traditional catalog. The 25-year term with 16-year PPT yields maximum wealth compounding.",
    "advisorNotesTe": "ఎల్‌ఐసి సాంప్రదాయ పొదుపు ప్లాన్లలో అత్యధిక లాభాన్ని ఇచ్చే నంబర్ వన్ పథకం."
  },
  {
    "id": "lic-jeevan-umang",
    "name": "LIC Jeevan Umang (Plan 945)",
    "nameTe": "ఎల్‌ఐసి జీవన్ ఉమాంగ్ (ప్లాన్ 945)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 945 | UIN: 512N312V02",
    "category": "retirement_planning",
    "type": "lic",
    "tag": "8% Guaranteed Annual Income Till 100",
    "tagTe": "100 ఏళ్ల వరకు 8% వార్షిక గ్యారెంటీడ్ రాబడి",
    "shortDesc": "Non-linked, whole life assurance plan providing annual survival benefits of 8% of Sum Assured from the end of premium paying term till age 99.",
    "shortDescTe": "ప్రీమియం చెల్లింపు పూర్తయిన తర్వాత నుండి 99 ఏళ్ల వరకు ప్రతి సంవత్సరం బేసిక్ సమ్ అష్యూర్డ్‌పై 8% వార్షిక ఆదాయం మరియు 100వ ఏట మెచ్యూరిటీ లభించే ప్లాన్.",
    "premium": "Starting @ ₹3,500/month",
    "premiumTe": "నెలకు ₹3,500 నుండి ప్రారంభం",
    "coverage": "₹2 Lakhs to No Limit",
    "coverageTe": "₹2 లక్షల నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "8% of Basic Sum Assured paid every single year until age 99",
      "Whole life risk coverage up to age 100",
      "Limited premium paying options: 15, 20, 25, or 30 years",
      "Accrues simple reversionary bonuses during premium paying term",
      "Lump sum maturity paid at age 100 with accumulated bonuses"
    ],
    "featuresTe": [
      "99 ఏళ్ల వయస్సు వరకు ప్రతి సంవత్సరం బేసిక్ సమ్ అష్యూర్డ్‌పై 8% ఖచ్చితమైన ఆదాయం",
      "100 సంవత్సరాల వరకు సంపూర్ణ జీవిత రిస్క్ కవరేజ్ భద్రత",
      "పరిమిత ప్రీమియం చెల్లింపు కాలాలు: 15, 20, 25, లేదా 30 సంవత్సరాలు",
      "ప్రీమియం చెల్లింపు కాలంలో ఎల్‌ఐసి వార్షిక బోనస్‌ల అర్హత",
      "100వ ఏట మెచ్యూరిటీ సమయంలో భారీ మొత్తం మరియు బోనస్‌ల చెల్లింపు"
    ],
    "eligibility": {
      "minAge": "90 days (completed)",
      "minAgeTe": "90 రోజులు",
      "maxAge": "55 years (for 15-yr PPT)",
      "maxAgeTe": "55 సంవత్సరాలు",
      "minSumAssured": "₹2,00,000 (No upper limit)",
      "minSumAssuredTe": "₹2,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "100 minus age at entry",
      "policyTermTe": "100 మైనస్ చేరిన వయస్సు",
      "ppt": "15, 20, 25, or 30 years",
      "pptTe": "15, 20, 25, లేదా 30 సంవత్సరాలు"
    },
    "keyBenefits": [
      "Lifetime Guaranteed 8% Cash Flow: 8% of Sum Assured credited tax-free under Section 10(10D) every single year.",
      "Generational Wealth: Grand maturity payout plus bonus given at age 100 or paid to family upon demise.",
      "Participating Bonuses: High bonus allocation during PPT boosts total portfolio return."
    ],
    "keyBenefitsTe": [
      "జీవితాంతం 8% స్థిర ఆదాయం: సెక్షన్ 10(10D) ప్రకారం ప్రతి సంవత్సరం పన్ను రహితంగా ఖాతాలో జమవుతుంది.",
      "తరతరాల ఆర్థిక భద్రత: 100 ఏళ్ల తర్వాత భారీ మొత్తం లేదా మరణానంతరం కుటుంబానికి శాశ్వత ఆర్థిక రక్షణ.",
      "ఎల్‌ఐసి బోనస్ ప్రయోజనాలతో కూడిన దీర్ఘకాలిక సంపద వృద్ధి."
    ],
    "limitations": [
      "Annual 8% cash flow starts only after complete payment of selected PPT (e.g. after 15 years).",
      "Loan facility max 90% of surrender value."
    ],
    "limitationsTe": [
      "ఎంచుకున్న ప్రీమియం చెల్లింపు కాలం పూర్తయిన తర్వాతే 8% వార్షిక ఆదాయం ప్రారంభమవుతుంది.",
      "సరెండర్ విలువపై గరిష్టంగా 90% వరకు మాత్రమే రుణం లభిస్తుంది."
    ],
    "payoutConditions": "Annual survival benefit of 8% of Basic Sum Assured paid starting from end of PPT till age 99. Lump sum paid at age 100 or on death.",
    "payoutConditionsTe": "ప్రీమియం కాలం ముగిసిన తర్వాత ప్రతి సంవత్సరం 8% చొప్పున 99 ఏళ్ల వరకు చెల్లించబడుతుంది. 100వ ఏట మెచ్యూరిటీ అందజేయబడుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "A classic whole-life plan that provides reliable annual pensions for parents while preserving a large tax-free inheritance for children.",
    "advisorNotesTe": "తల్లిదండ్రులకు స్థిరమైన పెన్షన్ మరియు పిల్లలకు భారీ వారసత్వ సంపదను అందించే అత్యుత్తమ జీవిత బీమా పథకం."
  },
  {
    "id": "lic-jeevan-lakshya",
    "name": "LIC Jeevan Lakshya (Plan 933)",
    "nameTe": "ఎల్‌ఐసి జీవన్ లక్ష్య (ప్లాన్ 933)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 933 | UIN: 512N297V02",
    "category": "children_future",
    "type": "lic",
    "tag": "Child Education Protection & Annual Income",
    "tagTe": "పిల్లల చదువుల భద్రత & వార్షిక ఆదాయ రక్షణ",
    "shortDesc": "Specially designed participating endowment plan ensuring annual income benefit to family in case of untimely demise of breadwinner plus full maturity at term.",
    "shortDescTe": "పాలసీదారునికి ఏదైనా అనుకోనిది జరిగితే కుటుంబానికి ప్రతి సంవత్సరం 10% వార్షిక ఆదాయం మరియు మెచ్యూరిటీ సమయంలో మళ్ళీ 110% పూర్తి మొత్తం అందించే రక్షణాత్మక పథకం.",
    "premium": "Starting @ ₹2,400/month",
    "premiumTe": "నెలకు ₹2,400 నుండి ప్రారంభం",
    "coverage": "₹1 Lakh to No Limit",
    "coverageTe": "₹1 లక్ష నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "10% of Basic Sum Assured paid annually to family from year of death till one year before maturity",
      "Future premiums waived completely upon death of policyholder",
      "Full Sum Assured (110%) + Vested Bonuses + FAB paid on maturity date regardless of prior payouts",
      "Limited premium payment: Pay for (Term minus 3) years",
      "Accidental benefit and term riders available"
    ],
    "featuresTe": [
      "పాలసీదారు మరణిస్తే మరుసటి సంవత్సరం నుండి మెచ్యూరిటీకి ముందు వరకు కుటుంబానికి ఏటా 10% ఆదాయం",
      "భవిష్యత్తు ప్రీమియంలన్నీ తక్షణమే పూర్తిగా రద్దు చేయబడతాయి",
      "మెచ్యూరిటీ తేదీన ఎలాంటి కోత లేకుండా 110% సమ్ అష్యూర్డ్ + పూర్తి బోనస్‌లు అందజేయబడతాయి",
      "పరిమిత ప్రీమియం: పాలసీ కాల వ్యవధి కంటే 3 సంవత్సరాలు తక్కువ చెల్లిస్తే సరిపోతుంది",
      "ప్రమాద బీమా మరియు టర్మ్ రైడర్ల సదుపాయం"
    ],
    "eligibility": {
      "minAge": "18 years (completed)",
      "minAgeTe": "18 సంవత్సరాలు",
      "maxAge": "50 years (nearer birthday)",
      "maxAgeTe": "50 సంవత్సరాలు",
      "minSumAssured": "₹1,00,000 (No upper limit)",
      "minSumAssuredTe": "₹1,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "13 to 25 years",
      "policyTermTe": "13 నుండి 25 సంవత్సరాలు",
      "ppt": "Policy term minus 3 years",
      "pptTe": "పాలసీ కాలం మైనస్ 3 సంవత్సరాలు"
    },
    "keyBenefits": [
      "Unbroken Child Education: If parent passes away, the child receives 10% of SA every year for school fees, and the original lump sum at maturity for college.",
      "No Financial Burden: All subsequent premiums are automatically cancelled upon unfortunate death.",
      "Triple Protection Effect: Combines annual family maintenance with guaranteed terminal wealth."
    ],
    "keyBenefitsTe": [
      "పిల్లల చదువులకు తిరుగులేని భరోసా: తండ్రి లేకపోయినా స్కూల్ ఫీజుల కోసం ఏటా 10% అందుతుంది, కాలేజీ సమయానికి పూర్తి మెచ్యూరిటీ వస్తుంది.",
      "కుటుంబంపై భారం సున్నా: మరణానంతరం ఒక్క రూపాయి కూడా ప్రీమియం చెల్లించాల్సిన పనిలేదు.",
      "వార్షిక నిర్వహణ ఖర్చులు మరియు భవిష్యత్తు మెచ్యూరిటీ రెండింటినీ సమకూర్చే రక్షణ కవచం."
    ],
    "limitations": [
      "Survival benefit only payable on maturity if policyholder survives (annual 10% is triggered upon demise).",
      "Minimum term is 13 years."
    ],
    "limitationsTe": [
      "పాలసీదారు జీవించి ఉంటే మెచ్యూరిటీ సమయంలో మాత్రమే మొత్తం అందుతుంది (వార్షిక 10% అనేది మరణించిన సందర్భంలో కుటుంబానికి సహాయం).",
      "కనిష్ట కాల వ్యవధి 13 సంవత్సరాలు."
    ],
    "payoutConditions": "On survival: Basic Sum Assured + Bonuses. On death: 10% SA paid annually until maturity, plus 110% SA + Bonuses paid on maturity date.",
    "payoutConditionsTe": "జీవించి ఉంటే మెచ్యూరిటీ నాడు పూర్తి మొత్తం. మరణిస్తే ఏటా 10% మరియు మెచ్యూరిటీ నాడు 110% సమ్ అష్యూర్డ్ + బోనస్‌లు చెల్లించబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "Popularly known as the \"Kanyadan\" or \"Child Higher Education\" guardian policy. No parent should plan child finances without reviewing Jeevan Lakshya.",
    "advisorNotesTe": "పిల్లల ఉన్నత విద్య మరియు ఆడపిల్లల వివాహ భవిష్యత్తు కోసం ప్రతి తల్లిదండ్రులు తప్పక తీసుకోవాల్సిన రక్షణాత్మక పథకం."
  },
  {
    "id": "lic-tech-term",
    "name": "LIC Tech Term (Plan 854)",
    "nameTe": "ఎల్‌ఐసి టెక్ టర్మ్ (ప్లాన్ 854)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 854 | UIN: 512N333V01",
    "category": "protect_family",
    "type": "lic",
    "tag": "Pure Online Risk Term Cover",
    "tagTe": "ఆన్‌లైన్ ప్యూర్ రిస్క్ టర్మ్ ఇన్సూరెన్స్",
    "shortDesc": "Non-participating, non-linked online pure risk premium life insurance plan providing high financial protection to insured family at economical rates.",
    "shortDescTe": "తక్కువ ప్రీమియంతో మీ కుటుంబానికి కోట్ల రూపాయల ఆర్థిక రక్షణ కల్పించే ఆన్‌లైన్ ప్యూర్ టర్మ్ ఇన్సూరెన్స్ ప్లాన్.",
    "premium": "Starting @ ₹600/month for ₹50 Lakh Cover",
    "premiumTe": "₹50 లక్షల కవరేజ్ నెలకు ₹600 నుండి ప్రారంభం",
    "coverage": "₹50 Lakhs to No Limit",
    "coverageTe": "₹50 లక్షల నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "Pure term insurance with sovereign guarantee under Section 37",
      "Special discounted premium rates for non-smokers and healthy individuals",
      "Choice of Level Sum Assured or Increasing Sum Assured (10% increase every year)",
      "Death benefit payout option in lump sum or staggered monthly installments",
      "High Sum Assured rebate on policy values above ₹1 Crore"
    ],
    "featuresTe": [
      "కేంద్ర ప్రభుత్వ సార్వభౌమ హామీతో కూడిన ప్యూర్ టర్మ్ ఇన్సూరెన్స్",
      "ధూమపానం చేయని వారికి మరియు ఆరోగ్యవంతులకు ప్రత్యేక ప్రీమియం రాయితీలు",
      "స్థిరమైన కవరేజ్ లేదా ప్రతి సంవత్సరం 10% పెరిగే ఇంక్రీజింగ్ సమ్ అష్యూర్డ్ ఎంపిక",
      "మరణానంతరం నామినీకి ఒకేసారి లేదా నెలవారీ వాయిదాలలో డబ్బులు అందే సదుపాయం",
      "₹1 కోటి కంటే ఎక్కువ కవరేజ్ తీసుకునే వారికి భారీ ప్రీమియం తగ్గింపు"
    ],
    "eligibility": {
      "minAge": "18 years (last birthday)",
      "minAgeTe": "18 సంవత్సరాలు",
      "maxAge": "65 years (last birthday)",
      "maxAgeTe": "65 సంవత్సరాలు",
      "minSumAssured": "₹50,00,000 (No upper limit)",
      "minSumAssuredTe": "₹50,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "10 to 40 years",
      "policyTermTe": "10 నుండి 40 సంవత్సరాలు",
      "ppt": "Regular Pay, Limited Pay (5 or 10 yrs), Single Pay",
      "pptTe": "రెగ్యులర్ పే, లిమిటెడ్ పే (5 లేదా 10 ఏళ్లు), సింగిల్ పే"
    },
    "keyBenefits": [
      "Huge Financial Umbrella: Secure ₹1 Crore to ₹5 Crore pure life cover for the price of a daily coffee.",
      "Increasing Cover Option: Sum Assured grows by 10% each year from year 6 to 15 to beat inflation.",
      "Nominee Security: Protect your home loans, children’s higher education, and spouse’s lifestyle completely."
    ],
    "keyBenefitsTe": [
      "భారీ కుటుంబ రక్షణ: రోజువారీ చిన్న ఖర్చుతోనే కుటుంబానికి ₹1 కోటి నుండి ₹5 కోట్ల జీవిత బీమా భద్రత.",
      "ద్రవ్యోల్బణాన్ని తట్టుకునేలా 6వ సంవత్సరం నుండి ఏటా 10% పెరిగే కవరేజ్ ఎంపిక.",
      "గృహ రుణాలు, పిల్లల విదేశీ విద్య మరియు కుటుంబ జీవన ప్రమాణాలకు పూర్తి ఆర్థిక భరోసా."
    ],
    "limitations": [
      "Pure protection plan: No maturity payout if insured survives the policy term.",
      "Strict medical underwriting and financial document verification required."
    ],
    "limitationsTe": [
      "ప్యూర్ ప్రొటెక్షన్ ప్లాన్: పాలసీ కాలంలో క్షేమంగా ఉంటే ఎలాంటి మెచ్యూరిటీ మొత్తం రాదు.",
      "ఖచ్చితమైన మెడికల్ పరీక్షలు మరియు ఆదాయ పత్రాల పరిశీలన తప్పనిసరి."
    ],
    "payoutConditions": "In case of unfortunate death of life assured during policy term, Sum Assured on Death is paid to nominee as chosen.",
    "payoutConditionsTe": "పాలసీ కాలంలో అనుకోని మరణం సంభవిస్తే ఎంచుకున్న పద్ధతిలో నామినీకి క్లెయిమ్ మొత్తం చెల్లించబడుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "A mandatory baseline safety net for every salaried or self-employed earner with dependents or home loans.",
    "advisorNotesTe": "ఆధారపడిన కుటుంబ సభ్యులు లేదా హోమ్ లోన్లు ఉన్న ప్రతి సంపాదించే వ్యక్తికి ఉండవలసిన ప్రాథమిక రక్షణ కవచం."
  },
  {
    "id": "lic-yuva-term",
    "name": "LIC Yuva Term (Plan 875)",
    "nameTe": "ఎల్‌ఐసి యువ టర్మ్ (ప్లాన్ 875)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 875 | UIN: 512N366V01",
    "category": "protect_family",
    "type": "lic",
    "tag": "Youth Focused Term Protection",
    "tagTe": "యువత కోసం ప్రత్యేక టర్మ్ బీమా",
    "shortDesc": "Affordable pure risk term plan crafted specifically for youngsters stepping into employment or corporate career.",
    "shortDescTe": "ఉద్యోగం లేదా వ్యాపారంలో అడుగుపెడుతున్న యువతీ యువకుల కోసం ప్రత్యేకంగా రూపొందించిన సరసమైన ప్యూర్ టర్మ్ ఇన్సూరెన్స్.",
    "premium": "Starting @ ₹450/month",
    "premiumTe": "నెలకు ₹450 నుండి ప్రారంభం",
    "coverage": "₹50 Lakhs to ₹5 Crores",
    "coverageTe": "₹50 లక్షల నుండి ₹5 కోట్లు",
    "features": [
      "Tailored for young earners aged 18 to 45 years",
      "Lowest entry premiums locking in your age advantage",
      "Level Sum Assured or Increasing Sum Assured options",
      "Optional Accidental Death Benefit rider",
      "Simple offline / agent assisted application process"
    ],
    "featuresTe": [
      "18 నుండి 45 ఏళ్ల యువ ఉద్యోగులు మరియు వ్యాపారుల కోసం ప్రత్యేక రూపకల్పన",
      "తక్కువ వయస్సులోనే అతి తక్కువ ప్రీమియంతో జీవితాంతం రేట్లు లాక్ చేసుకునే అవకాశం",
      "స్థిరమైన లేదా ఏటా పెరిగే కవరేజ్ ఆప్షన్లు",
      "ప్రమాద బీమా రైడర్ ప్రయోజనం",
      "అడ్వైజర్ సహాయంతో సులభంగా పాలసీ తీసుకునే వెసులుబాటు"
    ],
    "eligibility": {
      "minAge": "18 years",
      "minAgeTe": "18 సంవత్సరాలు",
      "maxAge": "45 years",
      "maxAgeTe": "45 సంవత్సరాలు",
      "minSumAssured": "₹50,00,000",
      "minSumAssuredTe": "₹50,00,000",
      "policyTerm": "10 to 40 years",
      "policyTermTe": "10 నుండి 40 సంవత్సరాలు",
      "ppt": "Regular Pay / Limited Pay",
      "pptTe": "రెగ్యులర్ పే / లిమిటెడ్ పే"
    },
    "keyBenefits": [
      "Lock-in Advantage: Buying in your 20s secures ultra-low premiums for the next 40 years.",
      "Financial Independence: Ensure your parents and spouse are never burdened with educational or personal liabilities."
    ],
    "keyBenefitsTe": [
      "తక్కువ వయస్సులోనే స్థిరమైన ప్రీమియం: 20 ఏళ్ల వయస్సులోనే చేరితే రాబోయే 40 ఏళ్ల వరకు అతి తక్కువ ప్రీమియంతో రక్షణ.",
      "తల్లిదండ్రులకు మరియు కుటుంబానికి విద్యా రుణాలు, వ్యక్తిగత బాధ్యతల నుండి శాశ్వత ఆర్థిక విముక్తి."
    ],
    "limitations": [
      "Maximum entry age restricted to 45 years.",
      "No survival benefit at maturity."
    ],
    "limitationsTe": [
      "గరిష్ట చేరిక వయస్సు 45 సంవత్సరాలు మాత్రమే.",
      "టర్మ్ పాలసీ కాబట్టి మెచ్యూరిటీ మొత్తం ఉండదు."
    ],
    "payoutConditions": "Full Sum Assured paid to nominees upon unfortunate demise during policy term.",
    "payoutConditionsTe": "పాలసీ కాలంలో మరణం సంభవిస్తే పూర్తి సమ్ అష్యూర్డ్ నామినీకి చెల్లించబడుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "Young professionals should purchase Yuva Term as their very first financial decision upon receiving their first appointment letter.",
    "advisorNotesTe": "ఉద్యోగంలో చేరిన వెంటనే మొదటి ఆర్థిక నిర్ణయంగా యువత తీసుకోవాల్సిన అత్యుత్తమ టర్మ్ ప్లాన్."
  },
  {
    "id": "lic-bima-jyoti",
    "name": "LIC Bima Jyoti (Plan 860)",
    "nameTe": "ఎల్‌ఐసి బీమా జ్యోతి (ప్లాన్ 860)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ ఆఫ్ ఇండియా (LIC)",
    "planNumber": "Plan No. 860 | UIN: 512N339V02",
    "category": "wealth_creation",
    "type": "lic",
    "tag": "₹50/Thousand Guaranteed Additions",
    "tagTe": "ప్రతి వేయికి ₹50 గ్యారెంటీడ్ అడిషన్స్",
    "shortDesc": "Non-linked, non-participating endowment plan offering guaranteed additions of ₹50 per thousand sum assured every single policy year.",
    "shortDescTe": "పాలసీ కాలం మొత్తం ప్రతి సంవత్సరం ప్రతి వేయి రూపాయల సమ్ అష్యూర్డ్‌పై ₹50 చొప్పున హామీతో కూడిన అదనపు ప్రయోజనాన్ని అందించే సురక్షిత పొదుపు పథకం.",
    "premium": "Starting @ ₹2,500/month",
    "premiumTe": "నెలకు ₹2,500 నుండి ప్రారంభం",
    "coverage": "₹1 Lakh to No Limit",
    "coverageTe": "₹1 లక్ష నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "Guaranteed Additions of ₹50 per thousand Basic Sum Assured accrued each policy year",
      "Pay premiums for 5 years less than policy term",
      "Policy terms available: 15 to 20 years",
      "Guaranteed surrender value and loan availability",
      "Complete death benefit throughout term"
    ],
    "featuresTe": [
      "పాలసీ కాలం మొత్తం ప్రతి సంవత్సరం ప్రతి వేయి రూపాయల సమ్ అష్యూర్డ్‌పై ₹50 ఖచ్చితమైన గ్యారెంటీడ్ అడిషన్స్",
      "పాలసీ కాల వ్యవధి కంటే 5 సంవత్సరాలు తక్కువ ప్రీమియం చెల్లింపు",
      "15 నుండి 20 సంవత్సరాల కాల పరిమితి ఎంపికలు",
      "నియమ నిబంధనల ప్రకారం లోన్ మరియు సరెండర్ సదుపాయం",
      "పాలసీ కాలంలో పూర్తి జీవిత బీమా రక్షణ"
    ],
    "eligibility": {
      "minAge": "90 days (completed)",
      "minAgeTe": "90 రోజులు",
      "maxAge": "60 years",
      "maxAgeTe": "60 సంవత్సరాలు",
      "minSumAssured": "₹1,00,000 (No upper limit)",
      "minSumAssuredTe": "₹1,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "15 to 20 years",
      "policyTermTe": "15 నుండి 20 సంవత్సరాలు",
      "ppt": "Policy term minus 5 years",
      "pptTe": "పాలసీ కాలం మైనస్ 5 సంవత్సరాలు"
    },
    "keyBenefits": [
      "Fixed Assured Compounding: Know your exact maturity amount from day one with ₹50/thousand GA.",
      "Shorter PPT: Pay for 10 years on a 15-year term or 15 years on a 20-year term.",
      "Tax Freedom: Maturity completely exempt under Section 10(10D)."
    ],
    "keyBenefitsTe": [
      "ఖచ్చితమైన లాభం: చేరిన రోజే మెచ్యూరిటీ మొత్తం ఎంత వస్తుందో ఖచ్చితంగా లెక్క చూసుకోవచ్చు.",
      "5 ఏళ్లు తక్కువ ప్రీమియం: 15 ఏళ్ల ప్లాన్‌కు 10 ఏళ్లు, 20 ఏళ్ల ప్లాన్‌కు 15 ఏళ్లు మాత్రమే చెల్లింపు.",
      "సెక్షన్ 10(10D) ప్రకారం మెచ్యూరిటీపై పూర్తి పన్ను మినహాయింపు."
    ],
    "limitations": [
      "Non-participating plan: No bonus increments beyond the contractual ₹50/thousand.",
      "Early surrender incurs penalties."
    ],
    "limitationsTe": [
      "నాన్-పార్టిసిపేటింగ్ ప్లాన్ కాబట్టి నిర్ణయించిన ₹50 కంటే అదనపు బోనస్ రాదు.",
      "ముందుగా రద్దు చేసుకుంటే నిబంధనల ప్రకారం రుసుములు వర్తిస్తాయి."
    ],
    "payoutConditions": "Basic Sum Assured + Accrued Guaranteed Additions (₹50/thousand per year) paid upon maturity or demise.",
    "payoutConditionsTe": "మెచ్యూరిటీ లేదా మరణానంతరం బేసిక్ సమ్ అష్యూర్డ్ + మొత్తం గ్యారెంటీడ్ అడిషన్స్ చెల్లించబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "A rock-solid savings instrument for investors who dislike equity market risk and want guaranteed maturity figures.",
    "advisorNotesTe": "మార్కెట్ రిస్క్ లేకుండా ఖచ్చితమైన రాబడి కోరుకునే వారికి ఎంతో నమ్మకమైన పొదుపు పథకం."
  },
  {
    "id": "lic-bima-ratna",
    "name": "LIC Bima Ratna (Plan 864)",
    "nameTe": "ఎల్‌ఐసి బీమా రత్న (ప్లాన్ 864)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ of India (LIC)",
    "planNumber": "Plan No. 864 | UIN: 512N345V01",
    "category": "wealth_creation",
    "type": "lic",
    "tag": "Guaranteed Money Back Plan",
    "tagTe": "హామీతో కూడిన మనీ బ్యాక్ ప్లాన్",
    "shortDesc": "Non-linked, non-participating money-back plan offering periodic survival benefits and ₹50 per thousand guaranteed additions.",
    "shortDescTe": "కాలానుగుణంగా మధ్యలో నగదు వాపసు ప్రయోజనాలు మరియు ప్రతి వేయికి ₹50 గ్యారెంటీడ్ అడిషన్స్ అందించే మనీ బ్యాక్ ప్లాన్.",
    "premium": "Starting @ ₹3,000/month",
    "premiumTe": "నెలకు ₹3,000 నుండి ప్రారంభం",
    "coverage": "₹5 Lakhs to No Limit",
    "coverageTe": "₹5 లక్షల నుండి గరిష్ట పరిమితి లేదు",
    "features": [
      "Guaranteed survival payouts of 25% of Sum Assured at specified intervals",
      "Guaranteed Additions of ₹50 per thousand Sum Assured accrued each year",
      "Short premium paying terms: 11, 16, or 21 years",
      "50% remaining Sum Assured + accumulated GA paid at maturity",
      "Loan facility available after 2 years"
    ],
    "featuresTe": [
      "పాలసీ మధ్యలో నిర్ణీత వ్యవధులలో బేసిక్ సమ్ అష్యూర్డ్‌పై 25% మనీ బ్యాక్ చెల్లింపులు",
      "ప్రతి సంవత్సరం ప్రతి వేయి రూపాయల సమ్ అష్యూర్డ్‌పై ₹50 గ్యారెంటీడ్ అడిషన్స్",
      "పరిమిత ప్రీమియం చెల్లింపు వ్యవధులు: 11, 16, లేదా 21 సంవత్సరాలు",
      "మెచ్యూరిటీ నాడు మిగిలిన 50% సమ్ అష్యూర్డ్ మరియు మొత్తం గ్యారెంటీడ్ అడిషన్స్ వాపసు",
      "2 సంవత్సరాల తర్వాత లోన్ సదుపాయం"
    ],
    "eligibility": {
      "minAge": "90 days (completed)",
      "minAgeTe": "90 రోజులు",
      "maxAge": "55 years",
      "maxAgeTe": "55 సంవత్సరాలు",
      "minSumAssured": "₹5,00,000 (No upper limit)",
      "minSumAssuredTe": "₹5,00,000 (గరిష్ట పరిమితి లేదు)",
      "policyTerm": "15, 20, or 25 years",
      "policyTermTe": "15, 20, లేదా 25 సంవత్సరాలు",
      "ppt": "11, 16, or 21 years",
      "pptTe": "11, 16, లేదా 21 సంవత్సరాలు"
    },
    "keyBenefits": [
      "Intermittent Liquidity: Enjoy 25% cash payouts before final maturity to fund home renovation or family vacations.",
      "Contractual Returns: Insulated from market bonus fluctuations."
    ],
    "keyBenefitsTe": [
      "మధ్యంతర నగదు ప్రయోజనాలు: పిల్లల చదువులు లేదా ఇంటి అవసరాల కోసం మధ్యలోనే 25% నగదు లభిస్తుంది.",
      "ఖచ్చితమైన హామీతో కూడిన ప్రభుత్వ రక్షణ."
    ],
    "limitations": [
      "Minimum Sum Assured is ₹5 Lakhs.",
      "Non-participating policy."
    ],
    "limitationsTe": [
      "కనిష్ట సమ్ అష్యూర్డ్ ₹5 లక్షలు.",
      "నాన్-పార్టిసిపేటింగ్ పాలసీ."
    ],
    "payoutConditions": "25% SA paid in last two policy years before maturity. Remaining 50% SA + GA paid on maturity date.",
    "payoutConditionsTe": "మెచ్యూరిటీకి ముందు రెండేళ్లలో 25% చొప్పున, మెచ్యూరిటీ నాడు మిగిలిన 50% మరియు బోనస్‌లు చెల్లించబడతాయి.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "A premium money back plan for businesses and executives requiring planned liquidity milestones.",
    "advisorNotesTe": "సమయానుకూలంగా డబ్బులు అవసరమయ్యే వ్యాపారులు మరియు ఉద్యోగులకు అత్యుత్తమ మనీ బ్యాక్ ప్లాన్."
  },
  {
    "id": "lic-siip",
    "name": "LIC SIIP (Plan 852)",
    "nameTe": "ఎల్‌ఐసి ఎస్ఐఐపి (ప్లాన్ 852)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ of India (LIC)",
    "planNumber": "Plan No. 852 | UIN: 512L334V01",
    "category": "wealth_creation",
    "type": "lic",
    "tag": "Market Linked with Refund of Mortality Charges",
    "tagTe": "మోర్టాలిటీ ఛార్జీల వాపసుతో కూడిన మార్కెట్ ప్లాన్",
    "shortDesc": "Unit-linked, regular premium life insurance plan that offers life cover, equity market returns, and complete refund of mortality charges at maturity.",
    "shortDescTe": "ఈక్విటీ మార్కెట్ లాభాలతో పాటు జీవిత బీమా రక్షణ మరియు మెచ్యూరిటీ సమయంలో వసూలు చేసిన మోర్టాలిటీ ఛార్జీలను 100% తిరిగి ఇచ్చే యూనిట్ లింక్డ్ ప్లాన్.",
    "premium": "Starting @ ₹3,334/month",
    "premiumTe": "నెలకు ₹3,334 నుండి ప్రారంభం",
    "coverage": "10x Annualized Premium",
    "coverageTe": "వార్షిక ప్రీమియంకు 10 రెట్లు",
    "features": [
      "100% refund of mortality charges added back into fund value at maturity",
      "Choice of 4 funds: Bond, Secured, Balanced, and Growth (equity focused)",
      "Guaranteed Additions added as percentage of annualized premium at specified years",
      "Free 4 switches between funds every policy year",
      "Partial withdrawals allowed after completion of 5th policy year"
    ],
    "featuresTe": [
      "మెచ్యూరిటీ నాడు పాలసీ కాలంలో వసూలు చేసిన మోర్టాలిటీ ఛార్జీలు 100% తిరిగి మీ ఫండ్‌లో జమ",
      "4 రకాల ఫండ్ల ఎంపిక: బాండ్, సెక్యూర్డ్, బ్యాలెన్స్‌డ్, మరియు గ్రోత్ (ఈక్విటీ ఫండ్)",
      "నిర్ణీత సంవత్సరాలలో పాలసీదారునికి ఉచిత గ్యారెంటీడ్ అడిషన్స్ జమ",
      "ప్రతి సంవత్సరం 4 ఉచిత ఫండ్ స్విచింగ్ సదుపాయాలు",
      "5 సంవత్సరాల లాక్-ఇన్ పీరియడ్ ముగిసిన తర్వాత పాక్షిక విత్‌డ్రాయల్ అవకాశం"
    ],
    "eligibility": {
      "minAge": "90 days (completed)",
      "minAgeTe": "90 రోజులు",
      "maxAge": "65 years",
      "maxAgeTe": "65 సంవత్సరాలు",
      "minSumAssured": "10 times annualized premium",
      "minSumAssuredTe": "వార్షిక ప్రీమియంకు 10 రెట్లు",
      "policyTerm": "10 to 25 years",
      "policyTermTe": "10 నుండి 25 సంవత్సరాలు",
      "ppt": "Equal to policy term",
      "pptTe": "పాలసీ కాలానికి సమానం"
    },
    "keyBenefits": [
      "Zero Net Cost of Insurance: Complete refund of mortality charges makes the cost of insurance virtually zero.",
      "Stock Market Upside: Benefit from Indian GDP growth and equities through LIC’s seasoned fund managers.",
      "Guaranteed Additions: Up to 25% of annual premium added by LIC at 25th policy year."
    ],
    "keyBenefitsTe": [
      "బీమా ఛార్జీలు సున్నా: మోర్టాలిటీ ఛార్జీలన్నీ మెచ్యూరిటీ నాడు తిరిగి రావడం వల్ల బీమా ఉచితంగా లభించినట్లే.",
      "ఈక్విటీ మార్కెట్ లాభాలు: భారత ఆర్థిక వ్యవస్థ వృద్ధితో పాటు మీ పెట్టుబడులు అధిక రాబడిని సాధిస్తాయి.",
      "ఎల్‌ఐసి నుండి లభించే అదనపు గ్యారెంటీడ్ అడిషన్స్ బోనస్."
    ],
    "limitations": [
      "Market risk is borne by the policyholder (investment returns fluctuate with NAV).",
      "Mandatory 5-year lock-in period applies under IRDAI guidelines."
    ],
    "limitationsTe": [
      "మార్కెట్ రిస్క్ పెట్టుబడిదారునిదే (NAV ఆధారంగా రాబడి మారుతుంది).",
      "ఐఆర్‌డిఎఐ నిబంధనల ప్రకారం కనీసం 5 సంవత్సరాల లాక్-ఇన్ పీరియడ్ ఉంటుంది."
    ],
    "payoutConditions": "Maturity: Total Unit Fund Value + Refund of Mortality Charges. Demise: Higher of Basic Sum Assured or Unit Fund Value.",
    "payoutConditionsTe": "మెచ్యూరిటీ నాడు మొత్తం ఫండ్ విలువ + మోర్టాలిటీ ఛార్జీల వాపసు. మరణానంతరం సమ్ అష్యూర్డ్ లేదా ఫండ్ విలువలో ఏది ఎక్కువైతే అది చెల్లించబడుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "Far superior to mutual funds plus term insurance because of the 100% refund of mortality charges and zero LTCG tax under Section 10(10D) (up to ₹2.5 Lakh annual premium).",
    "advisorNotesTe": "మోర్టాలిటీ ఛార్జీల వాపసు మరియు పన్ను రహిత ప్రయోజనాల వల్ల ఇది సాధారణ మ్యూచువల్ ఫండ్ల కంటే ఎంతో ప్రయోజనకరమైనది."
  },
  {
    "id": "lic-cancer-cover",
    "name": "LIC Cancer Cover (Plan 905)",
    "nameTe": "ఎల్‌ఐసి క్యాన్సర్ కవర్ (ప్లాన్ 905)",
    "officialInsurer": "Life Insurance Corporation of India (LIC)",
    "officialInsurerTe": "లైఫ్ ఇన్సూరెన్స్ కార్పొరేషన్ of India (LIC)",
    "planNumber": "Plan No. 905 | UIN: 512N314V02",
    "category": "protect_family",
    "type": "lic",
    "tag": "Fixed Benefit Cancer Insurance",
    "tagTe": "క్యాన్సర్ వ్యాధి రక్షణ బీమా పథకం",
    "shortDesc": "Regular premium health insurance plan providing fixed monetary payouts upon diagnosis of early or major stage cancer, irrespective of hospital bills.",
    "shortDescTe": "క్యాన్సర్ వ్యాధి ప్రారంభ లేదా తీవ్ర దశలో ఉన్నట్లు నిర్ధారణ అయితే ఆసుపత్రి బిల్లులతో సంబంధం లేకుండా నేరుగా భారీ నగదు పరిహారం అందించే ఆరోగ్య బీమా పథకం.",
    "premium": "Starting @ ₹250/month",
    "premiumTe": "నెలకు ₹250 నుండి ప్రారంభం",
    "coverage": "₹10 Lakhs to ₹50 Lakhs",
    "coverageTe": "₹10 లక్షల నుండి ₹50 లక్షలు",
    "features": [
      "Early Stage Cancer: 25% of Sum Assured paid immediately + future 3 years premiums waived",
      "Major Stage Cancer: 100% of Sum Assured paid + future all premiums waived completely",
      "Income Benefit: 1% of Sum Assured paid every month for 10 years upon Major Stage diagnosis",
      "Option of Level Sum Assured or Increasing Sum Assured (10% per year for first 5 years)",
      "Payouts made in addition to any existing mediclaim / health insurance"
    ],
    "featuresTe": [
      "ప్రారంభ దశ క్యాన్సర్: వెంటనే 25% సమ్ అష్యూర్డ్ నగదు చెల్లింపు + 3 సంవత్సరాల పాటు ప్రీమియంలు రద్దు",
      "తీవ్ర దశ క్యాన్సర్: 100% పూర్తి సమ్ అష్యూర్డ్ చెల్లింపు + భవిష్యత్తు ప్రీమియంలన్నీ జీవితాంతం రద్దు",
      "నెలవారీ ఆదాయ భరోసా: తీవ్ర దశ క్యాన్సర్‌కు 10 సంవత్సరాల పాటు ప్రతి నెలా 1% సమ్ అష్యూర్డ్ చెల్లింపు",
      "మొదటి 5 ఏళ్లలో ఏటా 10% పెరిగే సమ్ అష్యూర్డ్ ఎంపిక",
      "మీకు ఇప్పటికే ఉన్న మెడిక్లెయిమ్ లేదా ఇతర పాలసీలతో సంబంధం లేకుండా అదనంగా నగదు పరిహారం"
    ],
    "eligibility": {
      "minAge": "20 years (completed)",
      "minAgeTe": "20 సంవత్సరాలు",
      "maxAge": "65 years",
      "maxAgeTe": "65 సంవత్సరాలు",
      "minSumAssured": "₹10,00,000",
      "minSumAssuredTe": "₹10,00,000",
      "policyTerm": "10 to 30 years",
      "policyTermTe": "10 నుండి 30 సంవత్సరాలు",
      "ppt": "Equal to policy term",
      "pptTe": "పాలసీ కాలానికి సమానం"
    },
    "keyBenefits": [
      "Financial Independence: Lump sum payout can be used for non-medical living expenses, lost income, or overseas experimental treatment.",
      "120 Monthly Income Credits: 1% per month for 120 months ensures household income continues uninterrupted.",
      "Premium Waiver: Diagnosed patients are relieved of all future premium obligations."
    ],
    "keyBenefitsTe": [
      "ఆర్థిక స్వాతంత్ర్యం: లభించే నగదును ఆసుపత్రి ఖర్చులకే కాకుండా కుటుంబ అవసరాలు, ప్రయాణాలు లేదా ప్రత్యామ్నాయ వైద్యానికి వాడుకోవచ్చు.",
      "120 నెలల ఆదాయం: ప్రతి నెలా 1% చొప్పున పదేళ్ల పాటు క్రమం తప్పకుండా ఖాతాలో జమవుతుంది.",
      "భవిష్యత్తు ప్రీమియంలన్నీ రద్దు చేయబడతాయి."
    ],
    "limitations": [
      "Initial waiting period of 180 days from inception applies.",
      "Survival period of 7 days required after diagnosis.",
      "Pre-existing cancer is excluded."
    ],
    "limitationsTe": [
      "పాలసీ ప్రారంభమైన మొదటి 180 రోజుల వెయిటింగ్ పీరియడ్ ఉంటుంది.",
      "వ్యాధి నిర్ధారణ అయిన తర్వాత కనీసం 7 రోజులు జీవించి ఉండాలి.",
      "పాలసీకి ముందున్న క్యాన్సర్‌కు వర్తించదు."
    ],
    "payoutConditions": "Fixed monetary benefit paid directly to policyholder upon medical confirmation of cancer pathology report.",
    "payoutConditionsTe": "అధీకృత బయాప్సీ/పాథాలజీ రిపోర్ట్ సమర్పించిన వెంటనే నేరుగా పాలసీదారు ఖాతాలో నగదు జమ చేయబడుతుంది.",
    "officialSourceUrl": "https://licindia.in",
    "lastReviewed": "October 2026",
    "advisorNotes": "A life-saving monetary buffer that shields your family’s life savings against the catastrophic non-medical costs of prolonged oncology treatment.",
    "advisorNotesTe": "క్యాన్సర్ చికిత్సలో అయ్యే భారీ ఖర్చుల నుండి కుటుంబ ఆస్తులను కాపాడే అత్యంత ముఖ్యమైన రక్షణ కవచం."
  }
];

export const hdfcPlans = [
  {
    "id": "hdfc-ergo-optima-secure",
    "name": "HDFC ERGO Optima Secure",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా సెక్యూర్",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: HDFHLIP21008V012021",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "4X Coverage Multiplier Health Plan",
    "tagTe": "4 రెట్ల కవరేజ్ అందించే సూపర్ హెల్త్ ప్లాన్",
    "shortDesc": "Groundbreaking health insurance that automatically provides 4X coverage: 2X from day one, 3X in 2 years, plus 100% instant restoration and zero consumable deductions.",
    "shortDescTe": "మొదటి రోజు నుండే డబుల్ కవరేజ్, 2 ఏళ్లలో 3 రెట్లు, ఆటోమేటిక్ రిస్టోర్ మరియు 100% కన్స్యూమబుల్స్ చెల్లించే భారతదేశపు నంబర్ 1 హెల్త్ ఇన్సూరెన్స్.",
    "premium": "Starting @ ₹800/month",
    "premiumTe": "నెలకు ₹800 నుండి ప్రారంభం",
    "coverage": "₹5 Lakhs to ₹2 Crores",
    "coverageTe": "₹5 లక్షల నుండి ₹2 కోట్లు",
    "features": [
      "Secure Benefit: Additional 100% base cover given automatically from Day 1 at zero extra cost",
      "Plus Benefit: Base cover increases by 50% after Year 1 and 100% after Year 2 (regardless of claims)",
      "Restore Benefit: 100% base cover instantly restored 100% of the time upon any partial or full exhaustion",
      "Protect Benefit: Covers 100% of hospital non-medical consumables (PPE kits, gloves, sanitizers, syringes)",
      "Cashless hospitalization across 14,000+ empanelled hospitals with zero room rent capping"
    ],
    "featuresTe": [
      "సెక్యూర్ బెనిఫిట్: అదనపు ఖర్చు లేకుండా మొదటి రోజు నుండే 100% అదనపు కవరేజ్ (₹10L తీసుకుంటే ₹20L లభిస్తుంది)",
      "ప్లస్ బెనిఫిట్: క్లెయిమ్ చేసినా చేయకపోయినా రెండేళ్లలో కవరేజ్ 100% పెరుగుతుంది (మొత్తం 3X అవుతుంది)",
      "రిస్టోర్ బెనిఫిట్: కవరేజ్ పూర్తయిన వెంటనే అదే లేదా వేరే వ్యాధికి 100% ఆటోమేటిక్ రిస్టోర్ సదుపాయం",
      "ప్రొటెక్ట్ బెనిఫిట్: ఆసుపత్రి బిల్లులోని గ్లౌజులు, పీపీఈ కిట్లు, సిరంజీలు వంటి 68 రకాల నాన్-మెడికల్ వస్తువులకు 100% చెల్లింపు",
      "14,000+ నెట్‌వర్క్ ఆసుపత్రులలో రూమ్ రెంట్ పరిమితి లేని నగదు రహిత చికిత్స"
    ],
    "eligibility": {
      "minAge": "Adult: 18 yrs | Child: 91 days",
      "minAgeTe": "పెద్దలు: 18 ఏళ్లు | పిల్లలు: 91 రోజులు",
      "maxAge": "65 years (lifelong renewability thereafter)",
      "maxAgeTe": "65 సంవత్సరాలు (ఆ తర్వాత జీవితాంతం రెన్యూవల్)",
      "minSumAssured": "₹5,00,000",
      "minSumAssuredTe": "₹5,00,000",
      "policyTerm": "1, 2, or 3 years",
      "policyTermTe": "1, 2, లేదా 3 సంవత్సరాలు",
      "ppt": "Annual / Multi-year advance discount",
      "pptTe": "వార్షిక / బహుళ సంవత్సరాల ముందస్తు రాయితీ"
    },
    "keyBenefits": [
      "4X Coverage Multiplication: A ₹10 Lakh policy provides up to ₹40 Lakhs of actual hospitalization protection.",
      "No Room Rent Limits: Choose any hospital room category (Single Deluxe, Suite) without proportionate deduction penalties.",
      "Global Emergency Cover: Emergency medical hospitalization covered worldwide outside India (for ₹50L+ sum insured).",
      "60 Days Pre & 180 Days Post Hospitalization: Full diagnostic and post-discharge recovery costs reimbursed."
    ],
    "keyBenefitsTe": [
      "4 రెట్ల కవరేజ్ రక్షణ: ₹10 లక్షల పాలసీ తీసుకుంటే వాస్తవానికి ₹40 లక్షల వరకు ఆసుపత్రి ఖర్చుల రక్షణ లభిస్తుంది.",
      "రూమ్ రెంట్‌లో ఎలాంటి పరిమితులు లేవు: నచ్చిన డీలక్స్ రూమ్ ఎంచుకున్నా బిల్లులలో కోతలు ఉండవు.",
      "విదేశాలలో ఎమర్జెన్సీ కవరేజ్: ₹50 లక్షలు లేదా అంతకంటే ఎక్కువ కవరేజ్ ఉన్నవారికి అంతర్జాతీయ వైద్య రక్షణ.",
      "ఆసుపత్రికి చేరక ముందు 60 రోజుల మరియు డిశ్చార్జ్ తర్వాత 180 రోజుల వైద్య ఖర్చుల వాపసు."
    ],
    "limitations": [
      "Initial 30-day waiting period applies for non-accidental hospitalizations.",
      "24-month waiting period for specific listed illnesses (hernia, cataract, joint replacements).",
      "Pre-existing diseases covered after 36 months (can be reduced to 24 months with rider)."
    ],
    "limitationsTe": [
      "ప్రమాదాలు మినహా ఇతర వ్యాధులకు మొదటి 30 రోజుల వెయిటింగ్ పీరియడ్ ఉంటుంది.",
      "హెర్నియా, కంటిశుక్లం, కీళ్ల మార్పిడి వంటి వ్యాధులకు 24 నెలల వెయిటింగ్ పీరియడ్ ఉంటుంది.",
      "పాలసీకి ముందున్న వ్యాధులు 36 నెలల తర్వాత కవర్ చేయబడతాయి."
    ],
    "payoutConditions": "Cashless claims approved within 20 minutes across 14,000+ network hospitals in India.",
    "payoutConditionsTe": "భారతదేశంలోని 14,000+ నెట్‌వర్క్ ఆసుపత్రులలో 20 నిమిషాల్లో నగదు రహిత చికిత్స అనుమతులు జారీ చేయబడతాయి.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "The absolute gold standard in private Indian health insurance. The combination of 4X cover multiplier and Protect Benefit eliminates out-of-pocket medical bill shock.",
    "advisorNotesTe": "భారతదేశంలో ప్రైవేట్ హెల్త్ ఇన్సూరెన్స్‌లో తిరుగులేని నంబర్ 1 ప్లాన్. ఆసుపత్రి బిల్లుల్లో ఒక్క రూపాయి కూడా జేబు నుండి పెట్టాల్సిన పనిలేదు."
  },
  {
    "id": "hdfc-ergo-optima-restore",
    "name": "HDFC ERGO Optima Restore",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా రిస్టోర్",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: IRDAI/HLT/HDFCE/P-H/V.1/16/13-14",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "100% Instant Refill Health Policy",
    "tagTe": "100% ఆటోమేటిక్ రీఫిల్ హెల్త్ పాలసీ",
    "shortDesc": "Trusted comprehensive health insurance featuring instant 100% restore benefit for same or different illness, 50% yearly no-claim bonus, and lifelong renewability.",
    "shortDescTe": "ఒకసారి వాడుకున్న కవరేజ్ మళ్ళీ అదే లేదా వేరే అనారోగ్యానికి 100% ఉచితంగా రీఫిల్ అయ్యే అత్యంత నమ్మకమైన సమగ్ర ఆరోగ్య బీమా.",
    "premium": "Starting @ ₹650/month",
    "premiumTe": "నెలకు ₹650 నుండి ప్రారంభం",
    "coverage": "₹3 Lakhs to ₹50 Lakhs",
    "coverageTe": "₹3 లక్షల నుండి ₹50 లక్షలు",
    "features": [
      "Instant 100% Restore Benefit triggers immediately on partial or complete exhaustion of Sum Insured",
      "Multiplier Benefit: 50% increase in basic Sum Insured for every claim-free year, up to 100%",
      "Stay Active Benefit: Earn premium discounts by achieving daily step goals via mobile app",
      "Lifelong renewability with zero co-payment at any age",
      "Covers 586 day-care procedures without needing 24-hour hospitalization"
    ],
    "featuresTe": [
      "కవరేజ్ ఎంత వాడినా వెనువెంటనే 100% ఆటోమేటిక్ రీస్టోర్ సదుపాయం",
      "మల్టిప్లైయర్ బెనిఫిట్: క్లెయిమ్ లేని ప్రతి సంవత్సరానికి 50% నో క్లెయిమ్ బోనస్, గరిష్టంగా 100% వరకు",
      "స్టే యాక్టివ్ బెనిఫిట్: నడక మరియు ఆరోగ్యకరమైన వ్యాయామం ద్వారా ప్రీమియంలో రాయితీలు",
      "జీవితాంతం రెన్యూవల్ మరియు ఏ వయస్సు వారికైనా కో-పేమెంట్ సున్నా",
      "24 గంటలు ఉండాల్సిన అవసరం లేని 586 డే-కేర్ సర్జరీలకు పూర్తి రక్షణ"
    ],
    "eligibility": {
      "minAge": "Adult: 18 yrs | Child: 91 days",
      "minAgeTe": "పెద్దలు: 18 ఏళ్లు | పిల్లలు: 91 రోజులు",
      "maxAge": "65 years (lifelong renewability)",
      "maxAgeTe": "65 సంవత్సరాలు (జీవితాంతం రెన్యూవల్)",
      "minSumAssured": "₹3,00,000",
      "minSumAssuredTe": "₹3,00,000",
      "policyTerm": "1, 2, or 3 years",
      "policyTermTe": "1, 2, లేదా 3 సంవత్సరాలు",
      "ppt": "Annual premium",
      "pptTe": "వార్షిక ప్రీమియం"
    },
    "keyBenefits": [
      "Same Illness Restoration: Unlike older mediclaim policies, restore benefit applies even if hospitalised for the same condition after 45 days.",
      "Double Cover in 2 Claim-Free Years: A ₹5 Lakh policy doubles to ₹10 Lakhs with 50% yearly multiplier.",
      "No Sub-limits on Room Rent or Doctors’ Fees."
    ],
    "keyBenefitsTe": [
      "అదే వ్యాధికి కూడా రిస్టోర్: పాత కాలం పాలసీల్లా కాకుండా 45 రోజుల తర్వాత అదే వ్యాధి వచ్చినా మళ్ళీ పూర్తి కవరేజ్ లభిస్తుంది.",
      "రెండేళ్లలో రెట్టింపు కవరేజ్: క్లెయిమ్ లేకపోతే ₹5 లక్షల పాలసీ కాస్తా ₹10 లక్షలుగా మారుతుంది.",
      "రూమ్ రెంట్ లేదా వైద్యుల ఫీజులపై ఎలాంటి సబ్-లిమిట్లు ఉండవు."
    ],
    "limitations": [
      "Non-medical items (gloves, masks) deductible unless Optima Secure is chosen.",
      "Standard 30-day initial waiting period."
    ],
    "limitationsTe": [
      "నాన్-మెడికల్ వస్తువుల ఖర్చులు ఇందులో కవర్ కావు (వాటి కోసం ఆప్టిమా సెక్యూర్ తీసుకోవాలి).",
      "ప్రారంభ 30 రోజుల వెయిటింగ్ పీరియడ్ వర్తిస్తుంది."
    ],
    "payoutConditions": "Cashless claims settled directly with hospital; reimbursement claims settled within 7 days of invoice submission.",
    "payoutConditionsTe": "ఆసుపత్రిలో నేరుగా నగదు రహిత చికిత్స; రీయింబర్స్‌మెంట్ క్లెయిమ్‌లు బిల్లులు ఇచ్చిన 7 రోజుల్లో పరిష్కరించబడతాయి.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "A proven, battle-tested plan with over a decade of prompt claim settlement history. Ideal for budget-conscious families.",
    "advisorNotesTe": "దశాబ్ద కాలంగా లక్షలాది కుటుంబాల ఆదరణ పొందిన నమ్మకమైన బడ్జెట్ ఫ్రెండ్లీ హెల్త్ పాలసీ."
  },
  {
    "id": "hdfc-ergo-optima-senior",
    "name": "HDFC ERGO Optima Senior",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో ఆప్టిమా సీనియర్",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: IRDAI/HLT/HDFCE/P-H/V.1/18/13-14",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "Dedicated Senior Citizens Health Cover",
    "tagTe": "సీనియర్ సిటిజన్ల కోసం ప్రత్యేక ఆరోగ్య బీమా",
    "shortDesc": "Specialized health insurance crafted specifically for senior citizens and elderly parents (age 61+), covering age-related conditions, hospitalizations, and day-care treatments.",
    "shortDescTe": "61 సంవత్సరాలు పైబడిన వృద్ధ తల్లిదండ్రుల కోసం ప్రత్యేకంగా రూపొందించిన సమగ్ర ఆరోగ్య బీమా పథకం.",
    "premium": "Starting @ ₹2,200/month",
    "premiumTe": "నెలకు ₹2,200 నుండి ప్రారంభం",
    "coverage": "₹2 Lakhs to ₹5 Lakhs",
    "coverageTe": "₹2 లక్షల నుండి ₹5 లక్షలు",
    "features": [
      "Individual health cover specifically for parents and seniors aged 61 and above",
      "Pre-existing disease coverage option after specified waiting period",
      "No mandatory medical check-up up to age 65 (subject to clean declaration)",
      "Covers 586+ day care treatments and advanced surgical procedures",
      "Cashless hospital network of 14,000+ hospitals across India"
    ],
    "featuresTe": [
      "61 ఏళ్లు పైబడిన తల్లిదండ్రుల కోసం ప్రత్యేకంగా రూపొందించిన వ్యక్తిగత ఆరోగ్య బీమా",
      "నిర్ణీత వెయిటింగ్ పీరియడ్ తర్వాత గతంలో ఉన్న వ్యాధులకు కూడా పూర్తి చికిత్స రక్షణ",
      "ఆరోగ్య సమస్యలు లేకుంటే 65 ఏళ్ల వరకు ముందస్తు మెడికల్ టెస్ట్‌లు లేకుండానే చేరే అవకాశం",
      "586 రకాల డే-కేర్ ఆపరేషన్లకు మరియు సర్జరీలకు పూర్తి రక్షణ",
      "భారతదేశవ్యాప్తంగా 14,000 కంటే ఎక్కువ నెట్‌వర్క్ ఆసుపత్రులలో నగదు రహిత చికిత్స"
    ],
    "eligibility": {
      "minAge": "61 years",
      "minAgeTe": "61 సంవత్సరాలు",
      "maxAge": "No upper limit for entry",
      "maxAgeTe": "చేరడానికి గరిష్ట వయస్సు పరిమితి లేదు",
      "minSumAssured": "₹2,00,000",
      "minSumAssuredTe": "₹2,00,000",
      "policyTerm": "1 or 2 years",
      "policyTermTe": "1 లేదా 2 సంవత్సరాలు",
      "ppt": "Annual / Biennial",
      "pptTe": "వార్షిక / రెండేళ్ల ప్రీమియం"
    },
    "keyBenefits": [
      "Dignity in Old Age: Parents do not have to depend on children or liquidate investments for emergency hospitalizations.",
      "Pre & Post Hospitalization: 30 days pre and 60 days post hospitalization expenses covered.",
      "Tax Relief under Section 80D: Children paying premiums for parents aged 60+ receive up to ₹50,000 tax deduction."
    ],
    "keyBenefitsTe": [
      "వృద్ధాప్యంలో గౌరవప్రదమైన వైద్యం: అత్యవసర సమయాల్లో ఆస్తులు అమ్ముకోవాల్సిన పనిలేకుండా తల్లిదండ్రులకు అత్యున్నత వైద్యం.",
      "ఆసుపత్రికి చేరక ముందు 30 రోజులు మరియు డిశ్చార్జ్ తర్వాత 60 రోజుల వైద్య ఖర్చుల వాపసు.",
      "సెక్షన్ 80D పన్ను ప్రయోజనం: 60 ఏళ్లు దాటిన తల్లిదండ్రులకు ప్రీమియం చెల్లించే పిల్లలకు ఏటా ₹50,000 వరకు పన్ను తగ్గింపు."
    ],
    "limitations": [
      "Co-payment of 15% or 20% applies to senior claims depending on variant chosen.",
      "Pre-existing disease waiting period applies."
    ],
    "limitationsTe": [
      "ఎంచుకున్న విధానాన్ని బట్టి క్లెయిమ్‌పై 15% లేదా 20% కో-పేమెంట్ నిబంధన వర్తిస్తుంది.",
      "గతంలో ఉన్న వ్యాధులకు నిర్దిష్ట వెయిటింగ్ పీరియడ్ ఉంటుంది."
    ],
    "payoutConditions": "Cashless facility across 14,000+ empanelled hospitals upon pre-authorization approval.",
    "payoutConditionsTe": "ముందస్తు అనుమతితో 14,000+ ఆసుపత్రులలో నగదు రహిత చికిత్స సదుపాయం.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "NRIs and working professionals in Hyderabad with aging parents must secure Optima Senior to shield themselves from sudden multi-lakh hospital bills.",
    "advisorNotesTe": "వృద్ధులైన తల్లిదండ్రులు గల ప్రతి ఉద్యోగి మరియు ఎన్‌ఆర్‌ఐ తప్పనిసరిగా తీసుకోవాల్సిన అత్యవసర ఆరోగ్య రక్షణ."
  },
  {
    "id": "hdfc-ergo-my-health-suraksha",
    "name": "HDFC ERGO my:health Suraksha",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో మై:హెల్త్ సురక్ష",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: HDFHLIP20023V021920",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "Comprehensive Hospitalization & Mental Health",
    "tagTe": "సమగ్ర ఆసుపత్రి & మానసిక ఆరోగ్య రక్షణ",
    "shortDesc": "All-inclusive family health insurance offering zero room rent capping, air ambulance cover, organ donor expenses, and mental healthcare coverage.",
    "shortDescTe": "రూమ్ రెంట్ పరిమితులు లేని, ఎయిర్ అంబులెన్స్, ఆర్గాన్ డోనర్ మరియు మానసిక ఆరోగ్య చికిత్సలను కవర్ చేసే సమగ్ర ఫ్యామిలీ హెల్త్ పాలసీ.",
    "premium": "Starting @ ₹750/month",
    "premiumTe": "నెలకు ₹750 నుండి ప్రారంభం",
    "coverage": "₹3 Lakhs to ₹75 Lakhs",
    "coverageTe": "₹3 లక్షల నుండి ₹75 లక్షలు",
    "features": [
      "No room rent restriction or capping across all sum insured variants",
      "Air ambulance cover up to ₹5 Lakhs for critical medical transfer",
      "Covers mental health hospitalizations in compliance with Mental Healthcare Act",
      "Recovery benefit of ₹10,000 paid for hospitalization exceeding 10 consecutive days",
      "Optional Critical Illness and Parent Care add-on riders"
    ],
    "featuresTe": [
      "ఏ వేరియంట్‌లోనూ రూమ్ రెంట్‌పై ఎలాంటి పరిమితులు లేదా కోతలు లేవు",
      "అత్యవసర తరలింపు కోసం ₹5 లక్షల వరకు ఎయిర్ అంబులెన్స్ రక్షణ",
      "మెంటల్ హెల్త్‌కేర్ యాక్ట్ ప్రకారం మానసిక ఆరోగ్య ఆసుపత్రి చికిత్సలకు పూర్తి కవరేజ్",
      "10 రోజులకు మించి ఆసుపత్రిలో ఉంటే రికవరీ బెనిఫిట్‌గా ₹10,000 అదనపు నగదు చెల్లింపు",
      "క్రిటికల్ ఇల్‌నెస్ మరియు పేరెంట్ కేర్ అదనపు రైడర్ల సదుపాయం"
    ],
    "eligibility": {
      "minAge": "Adult: 18 yrs | Child: 91 days",
      "minAgeTe": "పెద్దలు: 18 ఏళ్లు | పిల్లలు: 91 రోజులు",
      "maxAge": "Lifelong entry & renewability",
      "maxAgeTe": "జీవితాంతం చేరే అవకాశం మరియు రెన్యూవల్",
      "minSumAssured": "₹3,00,000",
      "minSumAssuredTe": "₹3,00,000",
      "policyTerm": "1, 2, or 3 years",
      "policyTermTe": "1, 2, లేదా 3 సంవత్సరాలు",
      "ppt": "Annual / Multi-year",
      "pptTe": "వార్షిక / బహుళ సంవత్సరాలు"
    },
    "keyBenefits": [
      "Zero Room Rent Burden: Recover in comfort without worrying about hospital room limits.",
      "Alternative Medicine: AYUSH (Ayurveda, Yoga, Unani, Siddha, Homeopathy) inpatient hospitalizations covered.",
      "Organ Donor Coverage: Inpatient medical expenses of organ donor covered up to basic sum insured."
    ],
    "keyBenefitsTe": [
      "రూమ్ రెంట్‌లో స్వేచ్ఛ: ఎలాంటి నిబంధనలు లేకుండా మీకు నచ్చిన ప్రైవేట్ ఏసీ రూమ్ ఎంచుకోవచ్చు.",
      "ఆయుష్ వైద్యం: ఆయుర్వేద, యోగా, యునానీ, సిద్ధ, హోమియోపతి ఆసుపత్రి చికిత్సలకు పూర్తి రక్షణ.",
      "అవయవ దాత ఖర్చులు: అవయవ దాతకు అయ్యే ఆసుపత్రి ఖర్చులు కూడా పాలసీలోనే కవర్ చేయబడతాయి."
    ],
    "limitations": [
      "Standard 30-day initial waiting period applies.",
      "Specified surgeries have 24-month waiting duration."
    ],
    "limitationsTe": [
      "ప్రారంభ 30 రోజుల వెయిటింగ్ పీరియడ్ వర్తిస్తుంది.",
      "కొన్ని నిర్దిష్ట శస్త్రచికిత్సలకు 24 నెలల వెయిటింగ్ పీరియడ్ ఉంటుంది."
    ],
    "payoutConditions": "Cashless hospitalization settled directly with hospital; reimbursement claims processed in 7 working days.",
    "payoutConditionsTe": "ఆసుపత్రితో నేరుగా నగదు రహిత పరిష్కారం; రీయింబర్స్‌మెంట్ 7 పనిదినాల్లో పరిష్కరించబడుతుంది.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "A modern, flexible health policy that fills gaps left by older policies by including mental health and alternative AYUSH medicine.",
    "advisorNotesTe": "ఆధునిక కాలంలో మానసిక ఆరోగ్యం మరియు ఆయుర్వేద చికిత్సలను కూడా కవర్ చేసే సరికొత్త సమగ్ర హెల్త్ పాలసీ."
  },
  {
    "id": "hdfc-ergo-energy",
    "name": "HDFC ERGO Energy Health Insurance",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో ఎనర్జీ హెల్త్ ఇన్సూరెన్స్",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: HDFHLIP20020V021920",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "Diabetes & Hypertension Coverage From Day 1",
    "tagTe": "మధుమేహం & రక్తపోటు ఉన్నవారికి డే-1 రక్షణ",
    "shortDesc": "Pioneering health insurance specially created for individuals diagnosed with Type 1 & Type 2 Diabetes and Hypertension, offering Day-1 coverage options.",
    "shortDescTe": "షుగర్ (డయాబెటిస్) మరియు బీపీ (రక్తపోటు) ఉన్నవారికి మొదటి రోజు నుండే లేదా కేవలం 30 రోజుల తర్వాత నుండే ఆసుపత్రి ఖర్చుల రక్షణ కల్పించే ప్రత్యేక ఆరోగ్య బీమా.",
    "premium": "Starting @ ₹1,500/month",
    "premiumTe": "నెలకు ₹1,500 నుండి ప్రారంభం",
    "coverage": "₹2 Lakhs to ₹50 Lakhs",
    "coverageTe": "₹2 లక్షల నుండి ₹50 లక్షలు",
    "features": [
      "Specially designed for people with Type 1 & 2 Diabetes, Pre-diabetes, and Hypertension",
      "Option for Day-1 coverage for hospitalization arising out of diabetes and hypertension complications",
      "Personalized wellness and health coaching program included",
      "Free annual health check-up monitoring HbA1c, kidney function, and lipid profile",
      "No claim discount based on improved health parameters"
    ],
    "featuresTe": [
      "షుగర్ (టైప్ 1 & 2), ప్రీ-డయాబెటిస్ మరియు హైపర్‌టెన్షన్ ఉన్నవారి కోసం ప్రత్యేక రూపకల్పన",
      "షుగర్ మరియు బీపీ సమస్యల వల్ల వచ్చే ఆసుపత్రి ఖర్చులకు మొదటి రోజు నుండే రక్షణ పొందే అవకాశం",
      "వ్యక్తిగత వెల్నెస్ కోచ్ మరియు ఆరోగ్య సలహాల ఉచిత సేవలు",
      "ప్రతి సంవత్సరం ఉచితంగా HbA1c, కిడ్నీ మరియు లిపిడ్ ప్రొఫైల్ రక్త పరీక్షల సదుపాయం",
      "షుగర్ అదుపులో ఉంచుకుంటే తదుపరి రెన్యూవల్‌పై ప్రత్యేక ప్రీమియం రాయితీ"
    ],
    "eligibility": {
      "minAge": "18 years",
      "minAgeTe": "18 సంవత్సరాలు",
      "maxAge": "65 years (lifelong renewability)",
      "maxAgeTe": "65 సంవత్సరాలు (జీవితాంతం రెన్యూవల్)",
      "minSumAssured": "₹2,00,000",
      "minSumAssuredTe": "₹2,00,000",
      "policyTerm": "1 or 2 years",
      "policyTermTe": "1 లేదా 2 సంవత్సరాలు",
      "ppt": "Annual premium",
      "pptTe": "వార్షిక ప్రీమియం"
    },
    "keyBenefits": [
      "Overcomes Medical Rejection: Most insurers outright reject diabetic applicants; Energy specifically welcomes them.",
      "Day 1 Complication Safety: Protects against stroke, diabetic foot, retinopathy, and cardiac issues caused by chronic diabetes.",
      "Annual Diagnostic Tests: Comprehensive monitoring tests fully paid by insurer every policy year."
    ],
    "keyBenefitsTe": [
      "ఇతర కంపెనీల తిరస్కరణకు పరిష్కారం: సాధారణంగా షుగర్ ఉన్నవారికి ఇతర కంపెనీలు పాలసీ ఇవ్వవు; ఎనర్జీ ప్రత్యేకంగా వారికి రక్షణ ఇస్తుంది.",
      "డయాబెటిస్ సమస్యలకు మొదటి రోజు నుండే రక్షణ: షుగర్ వల్ల వచ్చే గుండె, కంటి మరియు కిడ్నీ సమస్యలకు పూర్తి చికిత్స భరోసా.",
      "ప్రతి సంవత్సరం పూర్తి ఉచిత డయాగ్నస్టిక్ రక్త పరీక్షలు."
    ],
    "limitations": [
      "Medical underwriting and latest medical reports required prior to policy issuance.",
      "Co-payment of 20% applies to diabetes-related claims in Silver variant."
    ],
    "limitationsTe": [
      "పాలసీ తీసుకునే ముందు తాజా రక్త పరీక్షల నివేదికల పరిశీలన తప్పనిసరి.",
      "సిల్వర్ ప్లాన్‌లో షుగర్ సంబంధిత క్లెయిమ్‌లపై 20% కో-పేమెంట్ ఉంటుంది."
    ],
    "payoutConditions": "Cashless claims approved across 14,000+ network hospitals in India.",
    "payoutConditionsTe": "భారతదేశంలోని 14,000+ ఆసుపత్రులలో నగదు రహిత చికిత్స చెల్లింపు.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "A blessing for individuals in Hyderabad and South India with diabetes who find it impossible to secure conventional health insurance elsewhere.",
    "advisorNotesTe": "డయాబెటిస్ మరియు బీపీ ఉన్నవారికి ఇతర కంపెనీలు పాలసీ నిరాకరించినప్పుడు ఇది ఒక గొప్ప వరప్రసాదం."
  },
  {
    "id": "hdfc-ergo-medisure-super-top-up",
    "name": "HDFC ERGO my:health Medisure Super Top Up",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో మై:హెల్త్ మెడిష్యూర్ సూపర్ టాప్ అప్",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: HDFHLIP20022V021920",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "High Cover Super Top-Up Health Plan",
    "tagTe": "భారీ కవరేజ్ సూపర్ టాప్-అప్ హెల్త్ ప్లాన్",
    "shortDesc": "Ultra cost-effective health plan that enhances your existing coverage up to ₹1 Crore with low premiums and high deductibles.",
    "shortDescTe": "మీకు ఇప్పటికే ఉన్న ఆఫీస్ లేదా బేసిక్ పాలసీపై అతి తక్కువ ప్రీమియంతో ₹1 కోటి వరకు భారీ అదనపు రక్షణ కల్పించే సూపర్ టాప్-అప్ ప్లాన్.",
    "premium": "Starting @ ₹250/month for ₹20 Lakh Cover",
    "premiumTe": "₹20 లక్షల కవరేజ్ నెలకు కేవలం ₹250 నుండి",
    "coverage": "₹10 Lakhs to ₹1 Crore",
    "coverageTe": "₹10 లక్షల నుండి ₹1 కోటి వరకు",
    "features": [
      "Enhances basic or corporate health cover up to ₹1 Crore at fractional cost",
      "Aggregate deductible: Calculates cumulative hospital bills across the entire year, not per claim",
      "No room rent sub-limits or capping",
      "Lifelong renewability without maximum exit age",
      "Cashless hospital network of 14,000+ hospitals"
    ],
    "featuresTe": [
      "కార్పొరేట్ లేదా సాధారణ హెల్త్ ఇన్సూరెన్స్‌ను అతి తక్కువ ఖర్చుతో ₹1 కోటి వరకు పెంచుకునే అవకాశం",
      "సంవత్సరంలో అన్ని ఆసుపత్రి బిల్లుల మొత్తాన్ని కలిపి లెక్కించే అగ్రిగేట్ డిడక్టబుల్ సదుపాయం",
      "రూమ్ రెంట్‌పై ఎలాంటి పరిమితులు లేదా కోతలు ఉండవు",
      "జీవితాంతం రెన్యూవల్ చేసుకునే పూర్తి హక్కు",
      "దేశవ్యాప్తంగా 14,000+ ఆసుపత్రులలో నగదు రహిత చికిత్స"
    ],
    "eligibility": {
      "minAge": "Adult: 18 yrs | Child: 91 days",
      "minAgeTe": "పెద్దలు: 18 ఏళ్లు | పిల్లలు: 91 రోజులు",
      "maxAge": "65 years (lifelong renewability thereafter)",
      "maxAgeTe": "65 సంవత్సరాలు (జీవితాంతం రెన్యూవల్)",
      "minSumAssured": "₹10,00,000 (Deductibles from ₹3L to ₹10L)",
      "minSumAssuredTe": "₹10,00,000 (డిడక్టబుల్ ₹3L నుండి ₹10L)",
      "policyTerm": "1 or 2 years",
      "policyTermTe": "1 లేదా 2 సంవత్సరాలు",
      "ppt": "Annual premium",
      "pptTe": "వార్షిక ప్రీమియం"
    },
    "keyBenefits": [
      "Huge Coverage on Tiny Budget: Pay only ₹3,000-₹5,000 per year to get ₹25-₹50 Lakhs additional protection.",
      "Complements Employer Group Insurance: Safeguards your family if employer cover proves inadequate during major surgeries.",
      "Single/Family Floater: Cover self, spouse, and up to 3 children under one single umbrella."
    ],
    "keyBenefitsTe": [
      "చిన్న బడ్జెట్‌తో భారీ రక్షణ: సంవత్సరానికి కేవలం ₹3,000 నుండి ₹5,000 చెల్లించి ₹25 నుండి ₹50 లక్షల అదనపు రక్షణ పొందవచ్చు.",
      "కంపెనీ ఇచ్చే ఇన్సూరెన్స్ తక్కువైనప్పుడు గుండె, క్యాన్సర్ వంటి పెద్ద ఆపరేషన్లకు ఇది సంపూర్ణ రక్షణ ఇస్తుంది.",
      "మొత్తం కుటుంబాన్ని ఒకే పాలసీ కింద చేర్చుకునే ఫ్లోటర్ సదుపాయం."
    ],
    "limitations": [
      "Hospital bills must exceed the chosen deductible (e.g. ₹5 Lakhs) before policy pays.",
      "Pre-existing diseases have 36-month waiting period."
    ],
    "limitationsTe": [
      "ఎంచుకున్న డిడక్టబుల్ మొత్తం (ఉదాహరణకు ₹5 లక్షలు) దాటిన తర్వాతే ఈ పాలసీ నుండి క్లెయిమ్ చెల్లించబడుతుంది.",
      "గతంలో ఉన్న వ్యాధులకు 36 నెలల వెయిటింగ్ పీరియడ్ ఉంటుంది."
    ],
    "payoutConditions": "Pays all inpatient medical costs above the chosen threshold deductible up to the high Sum Insured.",
    "payoutConditionsTe": "డిడక్టబుల్ పరిమితి దాటిన అన్ని ఇన్-పేషెంట్ వైద్య ఖర్చులను పూర్తిగా చెల్లిస్తుంది.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "The smartest and most cost-effective way to fight medical inflation. Every corporate employee with a modest ₹3L-₹5L office insurance must add a ₹50L Super Top Up.",
    "advisorNotesTe": "కార్పొరేట్ ఉద్యోగులు తమ ఆఫీస్ ఇన్సూరెన్స్‌కు అదనంగా ₹50 లక్షల రక్షణను అతి తక్కువ ఖర్చుతో సమకూర్చుకోవడానికి ఇది అత్యుత్తమ మార్గం."
  },
  {
    "id": "hdfc-ergo-critical-illness",
    "name": "HDFC ERGO Critical Illness Insurance",
    "nameTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో క్రిటికల్ ఇల్‌నెస్ ఇన్సూరెన్స్",
    "officialInsurer": "HDFC ERGO General Insurance Company",
    "officialInsurerTe": "హెచ్‌డిఎఫ్‌సి ఎర్గో జనరల్ ఇన్సూరెన్స్ కంపెనీ",
    "planNumber": "UIN: HDFHLIP21059V022021",
    "category": "health_insurance",
    "type": "hdfc",
    "tag": "15 Critical Illness Lump-Sum Protection",
    "tagTe": "15 ప్రాణాంతక వ్యాధులకు భారీ నగదు పరిహారం",
    "shortDesc": "Standalone health insurance that pays a 100% lump-sum cash benefit upon first diagnosis of 15 major critical illnesses including heart attack, cancer, and stroke.",
    "shortDescTe": "గుండెపోటు, క్యాన్సర్, పక్షవాతం వంటి 15 ప్రాణాంతక వ్యాధులు నిర్ధారణ అయిన వెంటనే ఆసుపత్రి బిల్లులతో సంబంధం లేకుండా 100% పూర్తి నగదు చెల్లించే హెల్త్ ప్లాన్.",
    "premium": "Starting @ ₹400/month",
    "premiumTe": "నెలకు ₹400 నుండి ప్రారంభం",
    "coverage": "₹5 Lakhs to ₹50 Lakhs",
    "coverageTe": "₹5 లక్షల నుండి ₹50 లక్షలు",
    "features": [
      "100% lump sum payout upon first verified diagnosis of any of 15 listed critical illnesses",
      "Covers Cancer, Heart Attack (Myocardial Infarction), Stroke, Major Organ Transplant, Kidney Failure, Permanent Paralysis, and Multiple Sclerosis",
      "Money can be used freely for debt payoff, overseas second opinions, or household living costs",
      "No bills or hospital invoices required; diagnosis report triggers payout",
      "Tax savings under Section 80D up to ₹25,000 (or ₹50,000 for seniors)"
    ],
    "featuresTe": [
      "జాబితాలోని 15 ప్రాణాంతక వ్యాధులలో ఏది నిర్ధారణ అయినా 100% నగదు ఒకేసారి చెల్లింపు",
      "క్యాన్సర్, గుండెపోటు, బ్రెయిన్ స్ట్రోక్, కిడ్నీ వైఫల్యం, అవయవ మార్పిడి, పక్షవాతం మొదలైన తీవ్ర వ్యాధులకు పూర్తి రక్షణ",
      "వచ్చిన నగదును ఆసుపత్రి ఖర్చులకే కాకుండా కుటుంబ అవసరాలు, అప్పులు తీర్చడం లేదా విదేశీ వైద్యానికి వాడుకోవచ్చు",
      "ఆసుపత్రి బిల్లులు అవసరం లేదు; సరైన వైద్య నిర్ధారణ నివేదిక ఉంటే సరిపోతుంది",
      "సెక్షన్ 80D ప్రకారం గరిష్టంగా ₹25,000 (సీనియర్లకు ₹50,000) వరకు ఆదాయపు పన్ను మినహాయింపు"
    ],
    "eligibility": {
      "minAge": "18 years",
      "minAgeTe": "18 సంవత్సరాలు",
      "maxAge": "65 years",
      "maxAgeTe": "65 సంవత్సరాలు",
      "minSumAssured": "₹5,00,000",
      "minSumAssuredTe": "₹5,00,000",
      "policyTerm": "1 or 2 years",
      "policyTermTe": "1 లేదా 2 సంవత్సరాలు",
      "ppt": "Annual / Biennial",
      "pptTe": "వార్షిక / రెండేళ్ల ప్రీమియం"
    },
    "keyBenefits": [
      "Income Protection: When serious illness prevents you from working for 6-12 months, the lump sum replaces your salary.",
      "Unrestricted Spending: Use the payout for specialized therapies not covered under standard mediclaim policies.",
      "Compliments Mediclaim: Paid in full even if your hospital bill was already 100% covered by another health policy."
    ],
    "keyBenefitsTe": [
      "ఆదాయానికి భరోసా: తీవ్ర అనారోగ్యం వల్ల ఉద్యోగానికి దూరమైతే మీ జీతానికి ప్రత్యామ్నాయంగా ఈ భారీ మొత్తం ఆదుకుంటుంది.",
      "ఖర్చులపై ఎలాంటి ఆంక్షలు లేవు: మీ ఇష్టానుసారం చికిత్సలకు, కుటుంబ ఖర్చులకు వాడుకోవచ్చు.",
      "ఇతర హెల్త్ పాలసీలతో సంబంధం లేదు: మీ ఆసుపత్రి బిల్లులు ఇతర పాలసీ ద్వారా చెల్లించబడినా, ఈ మొత్తం మీకు అదనంగా లభిస్తుంది."
    ],
    "limitations": [
      "Initial 90-day waiting period from policy commencement date.",
      "Survival period of 30 days following diagnosis is required before claim settlement."
    ],
    "limitationsTe": [
      "పాలసీ ప్రారంభమైన మొదటి 90 రోజుల వెయిటింగ్ పీరియడ్ వర్తిస్తుంది.",
      "వ్యాధి నిర్ధారణ జరిగిన తర్వాత పాలసీదారు కనీసం 30 రోజులు జీవించి ఉండాలి."
    ],
    "payoutConditions": "Lump-sum bank transfer made directly to policyholder within 14 days of confirmed medical pathology report.",
    "payoutConditionsTe": "అధీకృత వైద్య నివేదిక అందిన 14 రోజుల్లో పాలసీదారు బ్యాంక్ ఖాతాలో నేరుగా నగదు జమ చేయబడుతుంది.",
    "officialSourceUrl": "https://www.hdfcergo.com",
    "lastReviewed": "October 2026",
    "advisorNotes": "A standard mediclaim only reimburses hospital bills, but a Critical Illness policy protects your lifestyle, EMIs, and children’s education if a breadwinner is incapacitated.",
    "advisorNotesTe": "సాధారణ హెల్త్ పాలసీ ఆసుపత్రి బిల్లులు మాత్రమే కడుతుంది, కానీ క్రిటికల్ ఇల్‌నెస్ పాలసీ కుటుంబం రోడ్డున పడకుండా భారీ నగదుతో ఆదుకుంటుంది."
  }
];

export const allPolicies = [...licPlans, ...hdfcPlans];

export const getAllPlans = () => allPolicies;

export const getPolicyById = (id) => {
  return allPolicies.find((p) => p.id === id);
};

export const getCategoryLabel = (categoryKey, lang = 'en') => {
  const labels = {
    protect_family: {
      en: 'Family Protection & Term',
      te: 'కుటుంబ రక్షణ & టర్మ్ బీమా'
    },
    wealth_creation: {
      en: 'Wealth Creation & Savings',
      te: 'సంపద సృష్టి & పొదుపు పథకాలు'
    },
    children_future: {
      en: 'Child Education & Marriage',
      te: 'పిల్లల చదువు & వివాహ ప్రణాళిక'
    },
    retirement_planning: {
      en: 'Guaranteed Pension & Retirement',
      te: 'గ్యారెంటీడ్ పెన్షన్ & రిటైర్‌మెంట్'
    },
    health_insurance: {
      en: 'HDFC ERGO Health Insurance',
      te: 'హెచ్‌డిఎఫ్‌సి ఎర్గో ఆరోగ్య బీమా'
    }
  };
  return labels[categoryKey]?.[lang] || labels[categoryKey]?.en || categoryKey;
};


// Specialized Logic for Advanced NRI Calculator
export const calculateHDFCPolicyPremium = (members, baseCover = '25L', deductible = '0') => {
  if (!members || members.length === 0) return 0;
  
  let adultCount = 0;
  let childCount = 0;
  let maxAge = 0;

  members.forEach(m => {
    if (m.age > maxAge) maxAge = m.age;
    if (m.age > 24) adultCount++;
    else childCount++;
  });
  
  if (adultCount === 0 && childCount > 0) {
    adultCount = 1;
    childCount = childCount - 1;
  }

  const baseAdultPremium = 12000;
  const additionalAdultPremium = 8000;
  const childPremium = 4000;

  let totalPremium = baseAdultPremium 
    + (Math.max(0, adultCount - 1) * additionalAdultPremium) 
    + (childCount * childPremium);

  let ageMultiplier = 1.0;
  if (maxAge > 65) ageMultiplier = 2.8;
  else if (maxAge > 55) ageMultiplier = 2.0;
  else if (maxAge > 45) ageMultiplier = 1.5;
  else if (maxAge > 35) ageMultiplier = 1.2;
  
  let rawPremium = totalPremium * ageMultiplier;
  let scaledPremium = rawPremium * 1.1510416667;

  let factor = 1.0;
  if (baseCover === '25L') {
    if (deductible === '0') factor = 1.0;
    else if (deductible === '25K') factor = 0.8500;
    else if (deductible === '50K') factor = 0.7000;
  } else if (baseCover === '10L') {
    if (deductible === '0') factor = 0.79188;
    else if (deductible === '25K') factor = 0.5939;
    else if (deductible === '50K') factor = 0.4751;
  }

  return Math.round(scaledPremium * factor);
};
